import {
  Box,
  Button,
  Checkbox,
  Dropdown,
  DropdownItem,
  getColor,
  Icons,
  InputField,
  Modal,
  Radio,
  Tabs,
  Toggle,
  Tooltip,
  Typography,
  useToast,
} from "fds";
import { useEffect, useState } from "react";
import "./index.scss";
import { t } from "i18next";
import {
  AllowIpDto,
  ConfigDto,
  EcoSystemLicenseStats,
  FwocDto,
} from "../../types/adminConfig";

import {
  LoginDto,
  EcoCommonConfig as UserEcoCommonConfig,
} from "../../types/auth";

import useAdminConfigStore from "../../redux/dispatcher/useAdminConfigStore";
import useAdminSettingStore from "../../redux/dispatcher/useAdminSettingStore";
import {
  getAdminInfoFromLocalStorage,
  getUserInfoFromLocalStorage,
} from "../../shared/utils/auth";
import { AssignmentDto } from "../../types/adminSetting";
import utilsCommon from "../../shared/utils/common";
import WorkgroupAlarmPage from "./WorkgroupAlarmPage";
import {
  convertConfigEditor,
  convertConfigUnWrapping,
  convertConfigUser,
  convertConfigWebOfficeType,
} from "../../shared/utils/convertAdminMenuRight";
import { nanoid } from "@reduxjs/toolkit";
import i18n from "../../locales/i18n";

interface Props {
  isAdmin?: boolean;
}
const AdminConfig: React.FC<Props> = ({ isAdmin }) => {
  const toast = useToast();
  const {
    adminConfigStore,
    getConfig,
    updateConfig,
    getFwocConfigNew,
    getIpConfig,
    setIpConfig,
  } = useAdminConfigStore();
  const { adminSettingState, getAssingment } = useAdminSettingStore();

  const user = (
    isAdmin ? getAdminInfoFromLocalStorage() : getUserInfoFromLocalStorage()
  ) as string | "";
  const loginDto: LoginDto = JSON.parse(user);
  const myId = loginDto?.userInfo?.userId ?? "";

  const [userEcoCommonConfig, setUserCommonConfig] =
    useState<UserEcoCommonConfig>({} as UserEcoCommonConfig);
  const [ecoCommonConfig, setEcoCommonConfig] = useState<ConfigDto>(
    {} as ConfigDto
  );
  const [allowIpList, setAllowIpList] = useState([] as AllowIpDto[]);
  const [fwoc, setFwoc] = useState({} as FwocDto);
  const [assignmentList, setAssignmentList] = useState([] as AssignmentDto[]);
  const [userEcoSystemLicenseStats, setUserEcoSystemLicenseStats] =
    useState<EcoSystemLicenseStats>();
  const [openExtraModal, changeOpenExtraModal] = useState("CLOSE");
  const [tab, setTab] = useState(0);
  const [pageType, setPageType] = useState("view" as "view" | "edit");
  const [ecoCommonConfigTemp, setEcoCommonConfigTemp] = useState<ConfigDto>(
    {} as ConfigDto
  );
  const [allowIpListTemp, setAllowIpListTemp] = useState([] as AllowIpDto[]);
  const [buttonClick, changeButtonClick] = useState(0);
  const date = new Date();
  const serverTimezone = -date.getTimezoneOffset() / 60;

  useEffect(() => {
    const getConfigAll = async (): Promise<void> => {
      Promise.all([
        getConfig(),
        getFwocConfigNew(),
        getAssingment(),
        getIpConfig(),
      ]).then((results) => {
        // init();
      });
    };
    getConfigAll();
    const result = isAdmin
      ? getAdminInfoFromLocalStorage()
      : getUserInfoFromLocalStorage();

    if (result) {
      setUserCommonConfig(JSON.parse(result).ecoCommonConfig);
      setUserEcoSystemLicenseStats(JSON.parse(result).ecoSystemLicenseStats);
    }
  }, []);

  useEffect(() => {
    setEcoCommonConfig({
      ...adminConfigStore.config,
      workgroupPermissionDTO: {
        ...adminConfigStore.config?.workgroupPermissionDTO,
        policy: {
          ...adminConfigStore.config?.workgroupPermissionDTO?.policy,
          allowDaysTimeZone: serverTimezone,
          allowDays:
            adminConfigStore.config?.workgroupPermissionDTO?.policy
              .allowDays === -1
              ? -1
              : adminConfigStore.config?.workgroupPermissionDTO?.policy
                  .allowDays - 1,
          fileShareLinkPolicy: {
            ...adminConfigStore.config?.workgroupPermissionDTO?.policy
              ?.fileShareLinkPolicy,
            allowDays:
              !adminConfigStore.config?.workgroupPermissionDTO?.policy
                ?.fileShareLinkPolicy.allowDays ||
              adminConfigStore.config?.workgroupPermissionDTO?.policy
                ?.fileShareLinkPolicy?.allowDays === -1
                ? -1
                : adminConfigStore.config?.workgroupPermissionDTO?.policy
                    ?.fileShareLinkPolicy.allowDays - 1,
          },
        },
      },
      noneWorkgroupPolicyDTO: {
        ...adminConfigStore.config?.noneWorkgroupPolicyDTO,
        policy: {
          ...adminConfigStore.config?.noneWorkgroupPolicyDTO?.policy,
          allowDaysTimeZone: serverTimezone,
          allowDays:
            adminConfigStore.config?.noneWorkgroupPolicyDTO?.policy
              .allowDays === -1
              ? -1
              : adminConfigStore.config?.noneWorkgroupPolicyDTO?.policy
                  .allowDays - 1,
          fileShareLinkPolicy: {
            ...adminConfigStore.config?.noneWorkgroupPolicyDTO?.policy
              ?.fileShareLinkPolicy,
            allowDays:
              !adminConfigStore.config?.noneWorkgroupPolicyDTO?.policy
                ?.fileShareLinkPolicy.allowDays ||
              adminConfigStore.config?.noneWorkgroupPolicyDTO?.policy
                ?.fileShareLinkPolicy?.allowDays === -1
                ? -1
                : adminConfigStore.config?.noneWorkgroupPolicyDTO?.policy
                    ?.fileShareLinkPolicy.allowDays - 1,
          },
        },
      },
    });
  }, [adminConfigStore.config]);
  useEffect(() => {
    setFwoc(adminConfigStore.fwoc);
  }, [adminConfigStore.fwoc]);
  useEffect(() => {
    setAllowIpList(adminConfigStore.allowIp.allowIp ?? []);
  }, [adminConfigStore.allowIp]);
  useEffect(() => {
    setAssignmentList(adminSettingState.assignmentList ?? []);
  }, [adminSettingState.assignmentList]);

  const handleChangeConfigEdit = (name: string, value: any, title?: string) => {
    if (ecoCommonConfigTemp) {
      switch (name) {
        case "fileUploadMaxSizeMB":
          const maxSize =
            ecoCommonConfigTemp.serviceType &&
            ecoCommonConfigTemp.serviceType !== "CLOUD"
              ? userEcoCommonConfig.fileUploadConfigMaxSizeMB
              : 4096;
          if (Number(value) > maxSize) {
            setEcoCommonConfigTemp({
              ...ecoCommonConfigTemp,
              fileUploadMaxSizeMB: maxSize,
            });
          } else if (Number(value) < 1) {
            setEcoCommonConfigTemp({
              ...ecoCommonConfigTemp,
              fileUploadMaxSizeMB: 1,
            });
          } else {
            setEcoCommonConfigTemp({
              ...ecoCommonConfigTemp,
              fileUploadMaxSizeMB: Number(value),
            });
          }
          break;
        case "allowWINDOWS":
          setEcoCommonConfigTemp({
            ...ecoCommonConfigTemp,
            applicationPlatformPolicyDTO: {
              ...ecoCommonConfigTemp.applicationPlatformPolicyDTO,
              windows: {
                applicationDocumentViewerType:
                  value === "WEBOFFICE" ? "WEBOFFICE" : "NONE",
              },
            },
          });
          break;
        case "allowMacMobileApp":
          setEcoCommonConfigTemp({
            ...ecoCommonConfigTemp,
            applicationPlatformPolicyDTO: {
              ...ecoCommonConfigTemp.applicationPlatformPolicyDTO,
              macos: {
                applicationDocumentViewerType:
                  value === "WEBOFFICE" ? "WEBOFFICE" : "NONE",
              },
            },
          });
          break;
        case "selectWorkgroupHead":
          title === "" && value === "@@WORKGROUPCREATOR"
            ? setEcoCommonConfigTemp({
                ...ecoCommonConfigTemp,
                workgroupHeadSelectPermission: "@@WORKGROUPCREATOR",
              })
            : title === ""
            ? setEcoCommonConfigTemp({
                ...ecoCommonConfigTemp,
                workgroupHeadSelectPermission: value,
              })
            : setEcoCommonConfigTemp({
                ...ecoCommonConfigTemp,
                workgroupHeadSelectPermission: title + "",
              });
          break;
        case "watermarkOpacity":
          setEcoCommonConfigTemp({
            ...ecoCommonConfigTemp,
            watermarkOpacity: value,
          });
          break;
        case "folderMoveOwner":
          const folderMoveAllowType = ecoCommonConfigTemp.folderMoveAllowType;
          if (folderMoveAllowType) {
            setEcoCommonConfigTemp({
              ...ecoCommonConfigTemp,
              folderMoveAllowType: value,
            });
          } else {
            if (value === "MASTER") {
              setEcoCommonConfigTemp({
                ...ecoCommonConfigTemp,
                folderMoveOwner: true,
              });
            } else {
              setEcoCommonConfigTemp({
                ...ecoCommonConfigTemp,
                folderMoveOwner: false,
              });
            }
          }
          break;
        case "ecoCommonConfigPolicy":
          setEcoCommonConfigTemp({
            ...ecoCommonConfigTemp,
            workgroupPermissionDTO: {
              ...ecoCommonConfigTemp.workgroupPermissionDTO,
              policy: {
                ...ecoCommonConfigTemp.workgroupPermissionDTO?.policy,
                [title + ""]: value,
              },
            },
          });
          break;
        case "sendShareMail":
          setEcoCommonConfigTemp({
            ...ecoCommonConfigTemp,
            noneWorkgroupPolicyDTO: {
              ...ecoCommonConfigTemp.noneWorkgroupPolicyDTO,
              policy: {
                ...ecoCommonConfigTemp.noneWorkgroupPolicyDTO.policy,
                sendShareMail: value,
              },
            },
          });
          break;
        case "ecoNoneworkgroupConfigPolicy":
          setEcoCommonConfigTemp({
            ...ecoCommonConfigTemp,
            noneWorkgroupPolicyDTO: {
              ...ecoCommonConfigTemp.noneWorkgroupPolicyDTO,
              policy: {
                ...ecoCommonConfigTemp.noneWorkgroupPolicyDTO?.policy,
                [title + ""]: value,
              },
            },
          });
          break;
        case "fileUploadPermission":
          if (value === "INTERNAL") {
            if (ecoCommonConfigTemp.fileUploadPermission === "ADMIN") {
              setEcoCommonConfigTemp({
                ...ecoCommonConfigTemp,
                fileUploadPermission: "INTERNAL",
              });
            } else {
              setEcoCommonConfigTemp({
                ...ecoCommonConfigTemp,
                fileUploadPermission: "ADMIN",
              });
            }
          } else if (value === "EXTERNAL") {
            if (ecoCommonConfigTemp.fileUploadPermission === "EXTERNAL") {
              setEcoCommonConfigTemp({
                ...ecoCommonConfigTemp,
                fileUploadPermission: "INTERNAL",
              });
            } else {
              setEcoCommonConfigTemp({
                ...ecoCommonConfigTemp,
                fileUploadPermission: "EXTERNAL",
              });
            }
          }
          break;
        case "lastUpdateTime":
        case "licenseAlertPercentage":
          setEcoCommonConfigTemp({
            ...ecoCommonConfigTemp,
            [name]: Number(value),
          });
          break;
        case "allowMacOS":
          setEcoCommonConfigTemp({
            ...ecoCommonConfigTemp,
            allowMacOS: value === "true",
          });
          break;
        case "allowMobile":
          setEcoCommonConfigTemp({
            ...ecoCommonConfigTemp,
            allowMobile: value !== "false" ? true : false,
            applicationPlatformPolicyDTO: {
              ...ecoCommonConfigTemp.applicationPlatformPolicyDTO,
              ios: {
                applicationDocumentViewerType:
                  value === "NATIVE"
                    ? "NATIVE"
                    : value === "WEBOFFICE"
                    ? "WEBOFFICE"
                    : ecoCommonConfig.applicationPlatformPolicyDTO?.ios
                        ?.applicationDocumentViewerType,
              },
              android: {
                applicationDocumentViewerType:
                  value === "NATIVE"
                    ? "NATIVE"
                    : value === "WEBOFFICE"
                    ? "WEBOFFICE"
                    : ecoCommonConfigTemp.applicationPlatformPolicyDTO?.android
                        ?.applicationDocumentViewerType,
              },
            },
          });
          break;
        case "sentMail":
          setEcoCommonConfigTemp({
            ...ecoCommonConfigTemp,
            [name]: value === "true" ? true : false,
          });
          break;
        case "workgroupTreeViewPermission":
          setEcoCommonConfigTemp({
            ...ecoCommonConfigTemp,
            workgroupTreeCreatePermission:
              value === "NONE"
                ? "MASTER"
                : ecoCommonConfigTemp.workgroupTreeCreatePermission,
            [name]: value,
          });
          break;
        default:
          setEcoCommonConfigTemp({
            ...ecoCommonConfigTemp,
            [name]: value,
          });
          break;
      }
    }
  };

  const applyOtpType = (type: string) => {
    if (type === "INTERNAL") {
      return t("admin.dept.internalUser");
    } else if (type === "EXTERNAL") {
      return t("admin.dept.externalUser");
    } else if (type === "ALL") {
      return t("admin.common.label.allUser");
    } else if (type === "USE_SEPARATE_SETTING") {
      const internalOtp =
        ecoCommonConfig?.internalUserOtpType !== "NONE"
          ? ecoCommonConfig?.internalUserOtpType
          : t("admin.common.label.doNotUse");
      const externalOtp =
        ecoCommonConfig?.externalUserOtpType !== "NONE"
          ? ecoCommonConfig?.externalUserOtpType
          : t("admin.common.label.doNotUse");

      return (
        t("admin.dept.internalUser") +
        " : " +
        internalOtp +
        " / " +
        t("admin.dept.externalUser") +
        " : " +
        externalOtp
      );
    } else {
      return t("admin.common.label.noUser");
    }
  };

  const handleUseOtp = (type: string) => {
    if (ecoCommonConfigTemp) {
      setEcoCommonConfigTemp({
        ...ecoCommonConfigTemp,
        userOtpType: "USE_SEPARATE_SETTING",
      });

      if (type === "internal") {
        const internalOtp = ecoCommonConfigTemp.internalUserOtpType;
        setEcoCommonConfigTemp({
          ...ecoCommonConfigTemp,
          internalUserOtpType: internalOtp === "NONE" ? "GOOGLE_OTP" : "NONE",
        });
      } else {
        const externalOtp = ecoCommonConfigTemp.externalUserOtpType;
        setEcoCommonConfigTemp({
          ...ecoCommonConfigTemp,
          externalUserOtpType: externalOtp === "NONE" ? "GOOGLE_OTP" : "NONE",
        });
      }
    }
  };

  const addIpItem = (type: string) => {
    if (allowIpListTemp.length >= 50) {
      toast.toastMsg(nanoid(), t("admin.config.maxIpRangeNum"), "error");
      return;
    }
    if (type === "range") {
      setAllowIpListTemp(
        allowIpListTemp.concat({
          aclCode: "",
          ipFromStr: "0.0.0.0",
          ipToStr: "255.255.255.255",
          ipFrom: 0,
          ipTo: 4294967295,
          updatedTime: 0,
        })
      );
    } else {
      setAllowIpListTemp(
        allowIpListTemp.concat({
          aclCode: "",
          ipFromStr: "",
          ipToStr: "",
          ipFrom: 0,
          ipTo: 0,
          updatedTime: 0,
        })
      );
    }
  };

  const getIpClass = (ipStr: string, ipIdx: number) => {
    let ipStrToArray = ipStr.split(".");

    if (ipStrToArray[ipIdx] === "*") {
      if (ipStrToArray[3] === "0") {
        ipStrToArray[ipIdx] = "0";
      } else if (ipStrToArray[3] === "255") {
        ipStrToArray[ipIdx] = "255";
      }
    }

    return ipStrToArray[ipIdx];
  };

  const handleChangeIp = (listIdx: number, type: string, value: any) => {
    if (value.replace(/[*0-9]/g, "").length > 0) {
      return;
    }

    let allowIpList = [...allowIpListTemp];
    let allowIp = { ...allowIpList[listIdx] };
    let fromIpStr = allowIp.ipFromStr;
    let fromIpStrToArr = fromIpStr.split(".");
    let toIpStr = allowIp.ipToStr;
    let toIpStrToArr = toIpStr.split(".");

    switch (type) {
      case "fromIp1":
        if (value !== "*") {
          if (value > 255 || value < 0) {
            toast.toastMsg(nanoid(), t("admin.config.checkIPRange"), "error");
            return;
          } else {
            fromIpStrToArr[0] = value;
          }
        } else {
          fromIpStrToArr[0] = "0";
        }
        break;

      case "fromIp2":
        if (value !== "*") {
          if (value > 255 || value < 0) {
            toast.toastMsg(nanoid(), t("admin.config.checkIPRange"), "error");
            return;
          } else {
            fromIpStrToArr[1] = value;
          }
        } else {
          fromIpStrToArr[1] = "0";
        }

        break;
      case "fromIp3":
        if (value !== "*") {
          if (value > 255 || value < 0) {
            toast.toastMsg(nanoid(), t("admin.config.checkIPRange"), "error");
            return;
          } else {
            fromIpStrToArr[2] = value;
          }
        } else {
          fromIpStrToArr[2] = "0";
        }

        break;
      case "fromIp4":
        if (value !== "*") {
          if (value > 255 || value < 0) {
            toast.toastMsg(nanoid(), t("admin.config.checkIPRange"), "error");
            return;
          } else {
            fromIpStrToArr[3] = value;
          }
        } else {
          fromIpStrToArr[3] = "0";
        }

        break;
      case "toIp1":
        if (value !== "*") {
          if (value > 255 || value < 0) {
            toast.toastMsg(nanoid(), t("admin.config.checkIPRange"), "error");
            return;
          } else {
            toIpStrToArr[0] = value;
          }
        } else {
          toIpStrToArr[0] = "255";
        }

        break;
      case "toIp2":
        if (value !== "*") {
          if (value > 255 || value < 0) {
            toast.toastMsg(nanoid(), t("admin.config.checkIPRange"), "error");
            return;
          } else {
            toIpStrToArr[1] = value;
          }
        } else {
          toIpStrToArr[1] = "255";
        }

        break;
      case "toIp3":
        if (value !== "*") {
          if (value > 255 || value < 0) {
            toast.toastMsg(nanoid(), t("admin.config.checkIPRange"), "error");
            return;
          } else {
            toIpStrToArr[2] = value;
          }
        } else {
          toIpStrToArr[2] = "255";
        }

        break;
      case "toIp4":
        if (value !== "*") {
          if (value > 255 || value < 0) {
            toast.toastMsg(nanoid(), t("admin.config.checkIPRange"), "error");
            return;
          } else {
            toIpStrToArr[3] = value;
          }
        } else {
          toIpStrToArr[3] = "255";
        }

        break;
      default:
        break;
    }

    fromIpStr = fromIpStrToArr.join(".");
    toIpStr = toIpStrToArr.join(".");
    allowIp.ipFromStr = fromIpStr;
    allowIp.ipToStr = toIpStr;

    allowIpList[listIdx] = {
      ...allowIpList[listIdx],
      ipFromStr: fromIpStr,
      ipToStr: toIpStr,
    };

    setAllowIpListTemp(allowIpList);
  };

  const updateWatermarkPattern = (changeWatermark: string) => {
    let watermarkPattern = ecoCommonConfigTemp?.watermarkPattern;

    if (watermarkPattern) {
      const lastPos = watermarkPattern.lastIndexOf("/") + 2;
      watermarkPattern = watermarkPattern
        .substring(0, lastPos)
        .concat(changeWatermark);
    }

    handleChangeConfigEdit("watermarkPattern", watermarkPattern);
  };

  const handleChangeWatermark = (name: string) => {
    if (ecoCommonConfig) {
      let watermarkPatterns = ecoCommonConfigTemp.watermarkPattern;
      if (watermarkPatterns) {
        switch (name) {
          case "watermarkPatternWithTime":
            if (
              ecoCommonConfigTemp.watermarkPattern?.includes(
                "${currentfulltime}"
              )
            ) {
              watermarkPatterns = watermarkPatterns.replace(
                " / ${currentfulltime}",
                " / ${currenttime} "
              );
            } else {
              watermarkPatterns = watermarkPatterns.replace(
                " / ${currenttime}",
                " / ${currentfulltime} "
              );
            }
            break;
          case "watermarkPatternWithIp":
            if (ecoCommonConfigTemp.watermarkPattern?.includes("${ip}")) {
              watermarkPatterns = watermarkPatterns.replace(" / ${ip} ", "");
            } else {
              watermarkPatterns = watermarkPatterns.replace(
                " / ${contentname}",
                " / ${contentname} / ${ip} "
              );
            }
            break;
          default:
            break;
        }
        if (watermarkPatterns !== ecoCommonConfigTemp.watermarkPattern) {
          setEcoCommonConfigTemp({
            ...ecoCommonConfigTemp,
            watermarkPattern: watermarkPatterns,
          });
        }
      }
    }
  };

  const handleChangeFileLinkPolicy = (
    key: string,
    value: any,
    type: "workgroup" | "myBox"
  ) => {
    const linkPolicy =
      type === "workgroup"
        ? ecoCommonConfigTemp.workgroupPermissionDTO?.policy
            ?.fileShareLinkPolicy
        : ecoCommonConfigTemp.noneWorkgroupPolicyDTO.policy
            ?.fileShareLinkPolicy;
    const DEAULT_POLICY = {
      authType: "NONE", // NONE: 미인증, LOGIN: 인증, PASSWORD: 미인증-비밀번호
      password: "",
      urlAction: "WEBUSING_AND_DOWNLOAD",
      allowDays: -1,
      startTime: new Date().valueOf(),
      allowDaysTimeZone: 9.0,
    };
    if (type === "workgroup")
      setEcoCommonConfigTemp({
        ...ecoCommonConfigTemp,
        workgroupPermissionDTO: {
          ...ecoCommonConfigTemp.workgroupPermissionDTO,
          policy: {
            ...ecoCommonConfigTemp.workgroupPermissionDTO?.policy,
            fileShareLinkPolicy: {
              ...(linkPolicy ?? DEAULT_POLICY),
              [key]: value,
            },
          },
        },
      });
    else
      setEcoCommonConfigTemp({
        ...ecoCommonConfigTemp,
        noneWorkgroupPolicyDTO: {
          ...ecoCommonConfigTemp.noneWorkgroupPolicyDTO,
          policy: {
            ...ecoCommonConfigTemp.noneWorkgroupPolicyDTO.policy,
            fileShareLinkPolicy: {
              ...(linkPolicy ?? DEAULT_POLICY),
              [key]: value,
            },
          },
        },
      });
  };

  const checkFileShareLink = (type: "myBox" | "workgroup") => {
    const fileShareLinkPolicy =
      type === "myBox"
        ? (pageType === "view" ? ecoCommonConfig : ecoCommonConfigTemp)
            .noneWorkgroupPolicyDTO?.policy?.fileShareLinkPolicy
        : (pageType === "view" ? ecoCommonConfig : ecoCommonConfigTemp)
            .workgroupPermissionDTO?.policy?.fileShareLinkPolicy;
    return (
      <Box direction="column" width={"100%"}>
        <Box width={"100%"} classes="mg mt-12" alignItems="center">
          <Box width={"25%"}>
            <Radio
              label={t("admin.common.label.verified")}
              disable={pageType === "view"}
              check={fileShareLinkPolicy?.authType === "LOGIN"}
              onClick={() => {
                handleChangeFileLinkPolicy("authType", "LOGIN", type);
              }}
            />
          </Box>
          <Box alignItems="center" classes="mg ml-8">
            <Radio
              label={t("admin.common.label.unVerified")}
              disable={pageType === "view"}
              check={fileShareLinkPolicy?.authType !== "LOGIN"}
              onClick={() =>
                handleChangeFileLinkPolicy("authType", "NONE", type)
              }
            />
            <Dropdown
              classes="mg ml-16"
              btnSize="sm"
              placeholder=" "
              width={160}
              buttonClick={buttonClick}
              disabled={
                pageType === "view" || fileShareLinkPolicy?.authType === "LOGIN"
              }
              value={
                fileShareLinkPolicy?.urlAction === "DOWNLOAD"
                  ? t("admin.config.link.downloadOnly")
                  : fileShareLinkPolicy?.urlAction === "WEBUSING_AND_DOWNLOAD"
                  ? t("admin.config.link.preview") +
                    "&" +
                    t("admin.config.link.download")
                  : t("admin.config.link.previewOnly")
              }
            >
              {[
                {
                  title: t("admin.config.link.previewOnly"),
                  value: "WEBUSING",
                },
                {
                  title: t("admin.config.link.downloadOnly"),
                  value: "DOWNLOAD",
                },
                {
                  title:
                    t("admin.config.link.preview") +
                    "&" +
                    t("admin.config.link.download"),
                  value: "WEBUSING_AND_DOWNLOAD",
                },
              ].map((item) => (
                <DropdownItem
                  label={item.title}
                  onClick={() => {
                    handleChangeFileLinkPolicy("urlAction", item.value, type);
                    changeButtonClick(buttonClick + 1);
                  }}
                />
              ))}
            </Dropdown>
          </Box>
        </Box>
        {fileShareLinkPolicy?.authType !== "LOGIN" && (
          <Box
            classes="mg mt-12"
            direction="column"
            style={{ marginLeft: "420px" }}
          >
            <Box>
              <Checkbox
                label={t("admin.config.link.setEndDate")}
                disable={pageType === "view"}
                check={
                  fileShareLinkPolicy && fileShareLinkPolicy?.allowDays > -1
                }
                onClick={() =>
                  handleChangeFileLinkPolicy(
                    "allowDays",
                    fileShareLinkPolicy?.allowDays !== -1 ? -1 : 60,
                    type
                  )
                }
              />
            </Box>
            {fileShareLinkPolicy?.allowDays !== -1 && (
              <Box classes="adminConfig-info-colorBox2 mg mt-8">
                <InputField
                  width={100}
                  placeholder={""}
                  maxLength={3}
                  value={
                    fileShareLinkPolicy?.allowDays === -1
                      ? ""
                      : fileShareLinkPolicy?.allowDays + ""
                  }
                  type="positive-integer"
                  onChange={(e) =>
                    handleChangeFileLinkPolicy(
                      "allowDays",
                      e.target.value ? parseInt(e.target.value) : 0,
                      type
                    )
                  }
                  disabled={pageType === "view"}
                />

                <Typography type="body3_rg" classes="mg ml-12">
                  {t("admin.config.link.endAfter")}
                </Typography>
                <Typography
                  type="body3_rg"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  ({t("admin.config.link.dependDate")})
                </Typography>
              </Box>
            )}
          </Box>
        )}
      </Box>
    );
  };

  const updateConfigFunc = async (): Promise<void> => {
    let isInvalidConfig = false;
    const maxSize =
      ecoCommonConfigTemp.serviceType &&
      ecoCommonConfigTemp.serviceType !== "CLOUD"
        ? userEcoCommonConfig.fileUploadConfigMaxSizeMB
        : 4096;
    if (ecoCommonConfigTemp.fileUploadMaxSizeMB > maxSize) {
      toast.toastMsg(nanoid(), t("admin.config.maxMB", { maxSize }), "error");

      setEcoCommonConfigTemp({
        ...ecoCommonConfigTemp,
        fileUploadMaxSizeMB: maxSize,
      });
    } else if (ecoCommonConfigTemp.fileUploadMaxSizeMB < 1) {
      toast.toastMsg(nanoid(), t("admin.config.minMB"), "error");
      setEcoCommonConfigTemp({
        ...ecoCommonConfigTemp,
        fileUploadMaxSizeMB: 1,
      });
    } else if (
      !ecoCommonConfigTemp.passwordPolicyDTO ||
      !ecoCommonConfigTemp.passwordPolicyDTO?.minLength ||
      !ecoCommonConfigTemp.passwordPolicyDTO?.maxLength ||
      parseInt(ecoCommonConfigTemp.passwordPolicyDTO?.minLength + "") >
        parseInt(ecoCommonConfigTemp.passwordPolicyDTO?.maxLength + "")
    ) {
      toast.toastMsg(
        nanoid(),
        t("admin.config.passwordLengthInvalid"),
        "error"
      );
      return;
    } else if (
      parseInt(ecoCommonConfigTemp.passwordPolicyDTO?.minLength + "") < 6 ||
      parseInt(ecoCommonConfigTemp.passwordPolicyDTO?.maxLength + "") > 30
    ) {
      toast.toastMsg(
        nanoid(),
        t("admin.config.passwordLengthOutOfRange"),
        "error"
      );
      return;
    } else if (
      !utilsCommon.validationCompanyName(
        (ecoCommonConfigTemp?.watermarkPattern &&
          (ecoCommonConfigTemp?.watermarkPattern.substring(
            ecoCommonConfigTemp?.watermarkPattern.lastIndexOf("/") + 2
          ) === ""
            ? ""
            : ecoCommonConfigTemp.watermarkPattern.substring(
                ecoCommonConfigTemp?.watermarkPattern.lastIndexOf("/") + 2
              ))) + ""
      )
    ) {
      toast.toastMsg(nanoid(), t("admin.config.invalidCompanyName"), "error");
      isInvalidConfig = true;
    } else if (
      ecoCommonConfigTemp.watermarkFontSize > 20 ||
      ecoCommonConfigTemp.watermarkFontSize < 8
    ) {
      toast.toastMsg(
        nanoid(),
        t("admin.config.watermarkFontSizeWarning"),
        "error"
      );
      isInvalidConfig = true;
    } else if (
      ecoCommonConfigTemp.watermarkOpacity > 1 ||
      ecoCommonConfigTemp.watermarkOpacity < 0 ||
      isNaN(ecoCommonConfigTemp.watermarkOpacity)
    ) {
      toast.toastMsg(
        nanoid(),
        t("admin.config.watermarkOpacityWarning"),
        "error"
      );
      isInvalidConfig = true;
    } else if (
      ecoCommonConfigTemp.watermarkRotate > 180 ||
      ecoCommonConfigTemp.watermarkRotate < -180
    ) {
      toast.toastMsg(
        nanoid(),
        t("admin.config.watermarkRotateWarning"),
        "error"
      );
      isInvalidConfig = true;
    } else if (
      ecoCommonConfigTemp.watermarkTop > 100 ||
      ecoCommonConfigTemp.watermarkTop < 0
    ) {
      toast.toastMsg(nanoid(), t("admin.config.watermarkTopWarning"), "error");
      isInvalidConfig = true;
    } else {
      if (allowIpListTemp.length < 1) {
        toast.toastMsg(nanoid(), t("admin.config.minIpRangeNum"), "error");
        return;
      }

      allowIpListTemp.map((allowIp, idx) => {
        let fromIpArr = allowIp.ipFromStr;
        let toIpArr = allowIp.ipToStr;
        if (!utilsCommon.validationIpBand(fromIpArr, toIpArr)) {
          toast.toastMsg(nanoid(), t("admin.config.invalidIpAddress"), "error");
          isInvalidConfig = true;
          return;
        }
      });
      if (isInvalidConfig) return;
      const result: any = await updateConfig({
        ...ecoCommonConfigTemp,
        workgroupPermissionDTO: {
          ...ecoCommonConfigTemp.workgroupPermissionDTO,
          policy: {
            ...ecoCommonConfigTemp.workgroupPermissionDTO?.policy,
            allowDays:
              ecoCommonConfigTemp.workgroupPermissionDTO?.policy?.allowDays ===
              -1
                ? -1
                : Number(
                    ecoCommonConfigTemp.workgroupPermissionDTO?.policy
                      ?.allowDays
                  ) + 1,
            fileShareLinkPolicy: {
              ...ecoCommonConfigTemp.workgroupPermissionDTO?.policy
                ?.fileShareLinkPolicy,
              allowDays:
                ecoCommonConfigTemp.workgroupPermissionDTO?.policy
                  ?.fileShareLinkPolicy?.allowDays === -1
                  ? -1
                  : Number(
                      ecoCommonConfigTemp.workgroupPermissionDTO?.policy
                        ?.fileShareLinkPolicy?.allowDays
                    ) + 1,
            },
          },
        },
        noneWorkgroupPolicyDTO: {
          ...ecoCommonConfigTemp.noneWorkgroupPolicyDTO,
          policy: {
            ...ecoCommonConfigTemp.noneWorkgroupPolicyDTO?.policy,
            allowDays:
              ecoCommonConfigTemp.noneWorkgroupPolicyDTO?.policy?.allowDays ===
              -1
                ? -1
                : Number(
                    ecoCommonConfigTemp.noneWorkgroupPolicyDTO?.policy
                      ?.allowDays
                  ) + 1,
            fileShareLinkPolicy: {
              ...ecoCommonConfigTemp.noneWorkgroupPolicyDTO?.policy
                ?.fileShareLinkPolicy,
              allowDays:
                ecoCommonConfigTemp.noneWorkgroupPolicyDTO?.policy
                  ?.fileShareLinkPolicy?.allowDays === -1
                  ? -1
                  : Number(
                      ecoCommonConfigTemp.noneWorkgroupPolicyDTO?.policy
                        ?.fileShareLinkPolicy?.allowDays
                    ) + 1,
            },
          },
        },
      });

      const allowIpResult: any = await setIpConfig(allowIpListTemp);

      if (result.payload) {
        //result 업데이트 성공했을 때
        setPageType("view");
        if (allowIpResult) {
          toast.toastMsg(nanoid(), t("admin.common.alert.modify"), "success");
        } else {
          toast.toastMsg(
            nanoid(),
            t("admin.config.IPRangeUpdateFail"),
            "error"
          );
        }
      } else {
        toast.toastMsg(nanoid(), t("admin.common.alert.fail"), "error");
      }
    }
  };

  const ecoCommonConfigData =
    pageType === "view" ? ecoCommonConfig : ecoCommonConfigTemp;
  const showScreenWaterMark = () => {
    let returnScreenWtaterMark =
      ecoCommonConfigData.watermarkPattern?.includes("${currentfulltime}") &&
      ecoCommonConfigData.watermarkPattern?.includes("${ip}")
        ? t("admin.config.webSetting.watermarkPattern3")
        : ecoCommonConfigData.watermarkPattern?.includes("${currentfulltime}")
        ? t("admin.config.webSetting.watermarkPattern1")
        : ecoCommonConfigData.watermarkPattern?.includes("${ip}")
        ? t("admin.config.webSetting.watermarkPattern2")
        : t("admin.config.webSetting.watermarkPattern");
    returnScreenWtaterMark +=
      pageType === "view"
        ? ecoCommonConfigData?.watermarkPattern &&
          (ecoCommonConfigData?.watermarkPattern.substring(
            ecoCommonConfigData?.watermarkPattern.lastIndexOf("/") + 2
          ) === ""
            ? ""
            : ecoCommonConfigData.watermarkPattern.substring(
                ecoCommonConfigData?.watermarkPattern.lastIndexOf("/") + 2
              ))
        : "";
    return !i18n.language.includes("ar")
      ? returnScreenWtaterMark
      : returnScreenWtaterMark.split("/").reverse().join("/");
  };
  return (
    <Box classes="adminConfig" direction="column">
      <Box classes="adminConfig-title" justifyContent="space-between">
        <Typography type="h1">{t("admin.menu.config")}</Typography>
        <Box>
          {pageType === "view" && (
            <Button
              type="primary"
              btnStyle="fill"
              label={t("admin.common.button.modify")}
              onClick={() => {
                setEcoCommonConfigTemp(ecoCommonConfig);
                setAllowIpListTemp(allowIpList);
                setPageType("edit");
              }}
            />
          )}
          {pageType === "edit" && (
            <Box>
              <Button
                type="secondary"
                btnStyle="fill"
                label={t("admin.common.button.cancel")}
                onClick={() => {
                  setEcoCommonConfigTemp({} as ConfigDto);
                  setAllowIpListTemp([] as AllowIpDto[]);
                  setPageType("view");
                }}
              />
              <Button
                classes="mg ml-8"
                type="primary"
                btnStyle="fill"
                label={t("admin.common.button.ok")}
                onClick={() => {
                  //  setEcoCommonConfigTemp({} as ConfigDto);
                  //  setAllowIpListTemp([] as AllowIpDto[]);
                  updateConfigFunc();
                }}
              />
            </Box>
          )}
        </Box>
      </Box>
      <Box alignItems="center">
        <Typography type="body2_rg">{t("admin.config.updateDate")}</Typography>
        <Typography
          type="body2_rg"
          exactColor={getColor("COLOR_TEXT_BRAND")}
          classes="mg ml-4"
        >
          {utilsCommon.renderDateFormat(ecoCommonConfigData.lastUpdateTime)}
        </Typography>
      </Box>
      <Box classes="mg mt-24" width={"100%"}>
        <Tabs
          type={"leftFull"}
          tabs={[
            {
              color: "default",
              text: t("admin.config.uploadFile"),
            },
            {
              color: "default",
              text: t("admin.config.MyBoxSetting"),
            },
            {
              color: "default",
              text: t("admin.config.settingWorkgroup"),
              isHidden:
                loginDto?.ecoSystemLicenseStats?.featureAccessType === "LITE",
            },
            {
              color: "default",
              text: t("admin.config.settingAlarm"),
              isHidden:
                loginDto?.ecoSystemLicenseStats?.featureAccessType === "LITE",
            },
            {
              color: "default",
              text: t("admin.config.settingCommon"),
            },
          ]}
          style={{ width: "100%" }}
          selectTab={(value) => {
            setTab(value);
          }}
          selected={tab}
          size={"md"}
        />
      </Box>
      {tab === 0 && (
        <Box classes="adminConfig-tab mg mt-12" direction="column">
          {loginDto?.ecoSystemLicenseStats?.featureAccessType !== "LITE" && (
            <Box direction="row">
              <Box classes="adminConfig-subject">
                <Typography
                  type="subtitle2"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.config.uploadWrappingFile")}
                </Typography>
              </Box>
              <Box classes="adminConfig-info">
                {pageType === "view" && (
                  <Typography type="body2_rg">
                    {ecoCommonConfigData.restorePermission === "ALL"
                      ? t("admin.config.restorePermissionAll")
                      : ecoCommonConfigData.restorePermission === "MASTER"
                      ? t("admin.config.restorePermissionFile")
                      : t("admin.config.restorePermissionRevision")}
                  </Typography>
                )}
                {pageType === "edit" && (
                  <Box direction="row">
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        check={ecoCommonConfigData.restorePermission === "ALL"}
                        label={t("admin.config.restorePermissionAll")}
                        onClick={() =>
                          handleChangeConfigEdit("restorePermission", "ALL")
                        }
                      />
                    </Box>
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        check={
                          ecoCommonConfigData.restorePermission === "MASTER"
                        }
                        label={t("admin.config.restorePermissionFile")}
                        onClick={() =>
                          handleChangeConfigEdit("restorePermission", "MASTER")
                        }
                      />
                    </Box>
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        check={
                          ecoCommonConfigData.restorePermission === "REVISION"
                        }
                        label={t("admin.config.restorePermissionRevision")}
                        onClick={() =>
                          handleChangeConfigEdit(
                            "restorePermission",
                            "REVISION"
                          )
                        }
                      />
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          )}
          <Box direction="row">
            <Box classes="adminConfig-subject">
              <Typography
                type="subtitle2"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.config.maxFileSize")}
              </Typography>
            </Box>
            <Box classes="adminConfig-info">
              {(pageType === "view" ||
                ecoCommonConfigData.serviceType === "CLOUD") && (
                <Typography type="body2_rg">
                  {ecoCommonConfigData.fileUploadMaxSizeMB} MB
                </Typography>
              )}
              {pageType === "edit" &&
                ecoCommonConfigData.serviceType !== "CLOUD" && (
                  <Box alignItems="center">
                    <InputField
                      width={120}
                      placeholder={""}
                      value={ecoCommonConfigData.fileUploadMaxSizeMB + ""}
                      trailingIcon={
                        <Box direction={"column"}>
                          <span
                            style={{
                              height: "12px",
                              cursor: "pointer",
                              margin: "-4px 0 0 0",
                            }}
                            onClick={() =>
                              handleChangeConfigEdit(
                                "fileUploadMaxSizeMB",
                                ecoCommonConfigData.fileUploadMaxSizeMB + 1
                              )
                            }
                          >
                            <Icons
                              variant="line"
                              label="chevron"
                              direction="up"
                              size="12px"
                            />
                          </span>
                          <span
                            style={{
                              height: "12px",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              handleChangeConfigEdit(
                                "fileUploadMaxSizeMB",
                                ecoCommonConfigData.fileUploadMaxSizeMB - 1
                              )
                            }
                          >
                            <Icons
                              variant="line"
                              label="chevron"
                              direction="down"
                              size="12px"
                            />
                          </span>
                        </Box>
                      }
                      onChange={(e) =>
                        handleChangeConfigEdit(
                          "fileUploadMaxSizeMB",
                          e.target.value
                        )
                      }
                    />
                    <Box classes="mg ml-8">MB</Box>
                  </Box>
                )}
            </Box>
          </Box>
          {loginDto?.ecoSystemLicenseStats?.featureAccessType !== "LITE" && (
            <Box direction="row">
              <Box classes="adminConfig-subject">
                <Typography
                  type="subtitle2"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.config.fileUploadPermission")}
                </Typography>
              </Box>
              <Box classes="adminConfig-info">
                {pageType === "view" && (
                  <Typography type="body2_rg">
                    {ecoCommonConfigData.fileUploadPermission === "ADMIN"
                      ? t("admin.filter.userAdmin")
                      : ecoCommonConfigData.fileUploadPermission === "INTERNAL"
                      ? t("admin.filter.userAdmin") +
                        " / " +
                        t("admin.dept.internalUser")
                      : t("admin.filter.userAdmin") +
                        " / " +
                        t("admin.dept.internalUser") +
                        " / " +
                        t("admin.dept.externalUser")}
                  </Typography>
                )}
                {pageType === "edit" && (
                  <Box direction="row">
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Checkbox
                        label={t("admin.filter.userAdmin")}
                        check
                        disable
                      />
                    </Box>
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Checkbox
                        label={t("admin.dept.internalUser")}
                        check={
                          ecoCommonConfigData.fileUploadPermission !== "ADMIN"
                        }
                        onClick={() => {
                          handleChangeConfigEdit(
                            "fileUploadPermission",
                            "INTERNAL"
                          );
                        }}
                      />
                    </Box>
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Checkbox
                        label={t("admin.dept.externalUser")}
                        check={
                          ecoCommonConfigData.fileUploadPermission ===
                          "EXTERNAL"
                        }
                        disable={
                          ecoCommonConfigData.fileUploadPermission === "ADMIN"
                        }
                        onClick={() => {
                          handleChangeConfigEdit(
                            "fileUploadPermission",
                            "EXTERNAL"
                          );
                        }}
                      />
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          )}
          {loginDto?.ecoSystemLicenseStats?.featureAccessType !== "LITE" && (
            <Box direction="row">
              <Box classes="adminConfig-subject">
                <Typography
                  type="subtitle2"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.config.fileOwnerSelectPermission")}
                </Typography>
              </Box>
              <Box classes="adminConfig-info">
                {pageType === "view" && (
                  <Typography type="body2_rg">
                    {ecoCommonConfigData.fileOwnerSelectPermission ===
                    "FILEUPLOADER"
                      ? t("admin.config.fileUploader")
                      : t("admin.workgroup.manager")}
                  </Typography>
                )}
                {pageType === "edit" && (
                  <Box direction="row">
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        check={
                          ecoCommonConfigData.fileOwnerSelectPermission ===
                          "FILEUPLOADER"
                        }
                        label={t("admin.config.fileUploader")}
                        onClick={() =>
                          handleChangeConfigEdit(
                            "fileOwnerSelectPermission",
                            "FILEUPLOADER"
                          )
                        }
                      />
                    </Box>
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        check={
                          ecoCommonConfigData.fileOwnerSelectPermission ===
                          "WORKGROUPHEAD"
                        }
                        label={t("admin.workgroup.manager")}
                        onClick={() =>
                          handleChangeConfigEdit(
                            "fileOwnerSelectPermission",
                            "WORKGROUPHEAD"
                          )
                        }
                      />
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          )}
        </Box>
      )}
      {openExtraModal === "RESTRICT_SELECT_ALL" && (
        <Modal
          open={true}
          onClose={() => changeOpenExtraModal("CLOSE")}
          footer={
            <Box>
              <Button
                label={t("common.close")}
                btnStyle="fill"
                onClick={() => changeOpenExtraModal("CLOSE")}
              />
            </Box>
          }
          title={t("file.policy.chooseNormal")}
          width={540}
          bodyMsg={t("file.policy.chooseNormalInfo")}
        />
      )}
      {tab === 1 && (
        <Box classes="adminConfig-tab mg mt-12" direction="column">
          {!window.eco.isOnlyVerifiedLinkAllowed && (
            <Box direction="row">
              <Box classes="adminConfig-subject">
                <Typography
                  type="subtitle2"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.config.shareLinkDefault")}
                </Typography>
              </Box>
              <Box classes="adminConfig-info">
                {checkFileShareLink("myBox")}
              </Box>
            </Box>
          )}
          {ecoCommonConfigData.serviceType === "ONPREMISE" && (
            <Box direction="row">
              <Box classes="adminConfig-subject">
                <Typography
                  type="subtitle2"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.config.unWrap")}
                </Typography>
              </Box>
              <Box classes="adminConfig-info">
                {pageType === "view" && (
                  <Typography type="body2_rg">
                    {convertConfigUnWrapping(
                      ecoCommonConfigData.unwrappingPermission
                    )}
                  </Typography>
                )}
                {pageType === "edit" && (
                  <Box direction="row">
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        check={
                          ecoCommonConfigData.unwrappingPermission === "ALL"
                        }
                        label={convertConfigUnWrapping("ALL")}
                        onClick={() =>
                          handleChangeConfigEdit("unwrappingPermission", "ALL")
                        }
                      />
                    </Box>
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        check={
                          ecoCommonConfigData.unwrappingPermission ===
                          "INTERNAL_USER"
                        }
                        label={convertConfigUnWrapping("INTERNAL_USER")}
                        onClick={() =>
                          handleChangeConfigEdit(
                            "unwrappingPermission",
                            "INTERNAL_USER"
                          )
                        }
                      />
                    </Box>
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        check={
                          ecoCommonConfigData.unwrappingPermission === "MASTER"
                        }
                        label={convertConfigUnWrapping("MASTER")}
                        onClick={() =>
                          handleChangeConfigEdit(
                            "unwrappingPermission",
                            "MASTER"
                          )
                        }
                      />
                    </Box>
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        check={
                          ecoCommonConfigData.unwrappingPermission === "NONE"
                        }
                        label={convertConfigUnWrapping("NONE")}
                        onClick={() =>
                          handleChangeConfigEdit("unwrappingPermission", "NONE")
                        }
                      />
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          )}
          <Box direction="row">
            <Box classes="adminConfig-subject">
              <Typography
                type="subtitle2"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.config.alarmMail")}
              </Typography>
            </Box>
            <Box classes="adminConfig-info">
              <Box direction="row">
                <Box minWidth={"25%"} classes="mg mr-8">
                  <Radio
                    disable={pageType === "view"}
                    check={
                      ecoCommonConfigData.noneWorkgroupPolicyDTO.policy
                        ?.sendShareMail
                    }
                    label={t("admin.config.send")}
                    onClick={() =>
                      handleChangeConfigEdit("sendShareMail", true)
                    }
                  />
                </Box>
                <Box minWidth={"25%"} classes="mg mr-8">
                  <Radio
                    disable={pageType === "view"}
                    check={
                      !ecoCommonConfigData.noneWorkgroupPolicyDTO.policy
                        ?.sendShareMail
                    }
                    label={t("admin.config.noSend")}
                    onClick={() =>
                      handleChangeConfigEdit("sendShareMail", false)
                    }
                  />
                </Box>
              </Box>
            </Box>
          </Box>
          <Box direction="row">
            <Box classes="adminConfig-subject">
              <Typography
                type="subtitle2"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.config.defaultSetting")}
              </Typography>
            </Box>
            <Box classes="adminConfig-info">
              <Box direction="column">
                <Box classes="adminConfig-info-box">
                  <Box direction="column">
                    <Typography type="subtitle2">
                      {t("admin.config.editFile.title")}
                    </Typography>
                    <Typography
                      classes="mg mt-4"
                      type="body4_rg"
                      exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    >
                      {t("file.policy.revisionSendFileDesc")}
                    </Typography>
                  </Box>
                  <Toggle
                    disabled={pageType === "view"}
                    checked={
                      ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                        ?.revision
                    }
                    onChange={() => {
                      handleChangeConfigEdit(
                        "ecoNoneworkgroupConfigPolicy",
                        !ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                          ?.revision,
                        "revision"
                      );
                    }}
                  />
                </Box>
                <Box classes="adminConfig-info-box">
                  <Box direction="column">
                    <Box>
                      <Typography type="subtitle2">
                        {t("admin.config.downloadFile.title")}
                      </Typography>
                      <Tooltip message={t("admin.config.downloadFile.tooltip")}>
                        <Icons
                          variant="fill"
                          label="questionmark"
                          classes="mg ml-4"
                        />
                      </Tooltip>
                    </Box>
                    <Typography
                      classes="mg mt-4"
                      type="body4_rg"
                      exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    >
                      {t("file.policy.downloadSendFileDesc")}
                    </Typography>
                  </Box>
                  <Toggle
                    disabled={pageType === "view"}
                    checked={
                      ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                        ?.download
                    }
                    onChange={() => {
                      handleChangeConfigEdit(
                        "ecoNoneworkgroupConfigPolicy",
                        !ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                          ?.download,
                        "download"
                      );
                    }}
                  />
                </Box>
                {ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                  ?.download && (
                  <Box classes="adminConfig-info-box mg mt-20">
                    <Box
                      direction="column"
                      width={
                        ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                          ?.wrapping
                          ? "calc(100% - 148px)"
                          : "100%"
                      }
                    >
                      <Box alignItems="center">
                        <Checkbox
                          disable={pageType === "view"}
                          label={t("admin.config.advancedSecurity.title")}
                          check={
                            ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                              ?.wrapping
                          }
                          onClick={() => {
                            handleChangeConfigEdit(
                              "ecoNoneworkgroupConfigPolicy",
                              !ecoCommonConfigData?.noneWorkgroupPolicyDTO
                                ?.policy?.wrapping,
                              "wrapping"
                            );
                          }}
                        />
                        <Tooltip
                          message={t(
                            "admin.config.advancedSecurity.noApplyMac"
                          )}
                        >
                          <Icons
                            variant="fill"
                            label="questionmark"
                            classes="mg ml-4 mt-4"
                          />
                        </Tooltip>
                      </Box>
                      <Tooltip
                        message={`${t(
                          "admin.config.advancedSecurity.extensions"
                        )}: ${[
                          ...new Set([
                            ...(utilsCommon.getServiceConfig(
                              true,
                              "revisionExtensions"
                            ) || []),
                            ...(utilsCommon.getServiceConfig(
                              true,
                              "manualRevisionExtensions"
                            ) || []),
                          ]),
                        ]
                          .filter((ext) => !!ext)
                          .map((ext) => ext)
                          .sort((a, b) => (a < b ? -1 : 1))
                          .join(", ")}`}
                      >
                        <Typography
                          ellipsis
                          classes="mg ml-28"
                          type="body4_rg"
                          exactColor={getColor("COLOR_TEXT_SECONDARY")}
                        >
                          {t("admin.config.advancedSecurity.extensions")}:{" "}
                          {[
                            ...new Set([
                              ...(utilsCommon.getServiceConfig(
                                true,
                                "revisionExtensions"
                              ) || []),
                              ...(utilsCommon.getServiceConfig(
                                true,
                                "manualRevisionExtensions"
                              ) || []),
                            ]),
                          ]
                            .filter((ext) => !!ext)
                            .map((ext) => ext)
                            .sort((a, b) => (a < b ? -1 : 1))
                            .join(", ")}
                        </Typography>
                      </Tooltip>
                    </Box>
                    {ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                      ?.wrapping &&
                      pageType === "view" && (
                        <Typography type="body2_rg">
                          {ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                            ?.wrapping &&
                          ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                            ?.drmPerm?.length === 0
                            ? t("admin.config.advancedSecurity.normal")
                            : t("admin.config.advancedSecurity.advanced")}
                        </Typography>
                      )}
                    {ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                      ?.wrapping &&
                      pageType === "edit" && (
                        <Dropdown
                          classes="mg ml-16"
                          btnSize="sm"
                          placeholder=" "
                          width={160}
                          buttonClick={buttonClick}
                          value={
                            ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                              ?.wrapping &&
                            ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                              ?.drmPerm?.length === 0
                              ? t("admin.config.advancedSecurity.normal")
                              : t("admin.config.advancedSecurity.advanced")
                          }
                        >
                          <DropdownItem
                            label={t("admin.config.advancedSecurity.normal")}
                            onClick={() => {
                              handleChangeConfigEdit(
                                "ecoNoneworkgroupConfigPolicy",
                                [],
                                "drmPerm"
                              );
                              changeButtonClick(buttonClick + 1);
                            }}
                          />
                          <DropdownItem
                            label={t("admin.config.advancedSecurity.advanced")}
                            onClick={() => {
                              handleChangeConfigEdit(
                                "ecoNoneworkgroupConfigPolicy",
                                ["view"],
                                "drmPerm"
                              );
                              changeButtonClick(buttonClick + 1);
                            }}
                          />
                        </Dropdown>
                      )}
                  </Box>
                )}
                {ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                  ?.download &&
                  ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                    ?.drmPerm &&
                  ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                    ?.wrapping &&
                  ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy?.drmPerm
                    ?.length > 0 && (
                    <Box classes="adminConfig-info-colorBox mg mt-32">
                      {[
                        {
                          title: t("admin.config.advancedSecurity.print"),
                          value: "print",
                        },
                        {
                          title: t("admin.config.advancedSecurity.printScreen"),
                          value: "print_screen",
                        },
                        {
                          title: t("admin.config.advancedSecurity.copyDoc"),
                          value: "extract",
                        },
                      ].map((item, index) => (
                        <Box
                          justifyContent="space-between"
                          width={"100%"}
                          classes={index > 0 ? "mg mt-16" : ""}
                        >
                          <Typography
                            type="body2_rg"
                            exactColor={getColor("COLOR_TEXT_SECONDARY")}
                          >
                            {item.title}
                          </Typography>
                          <Box classes="radioGroups">
                            <Radio
                              label={t("admin.config.policy.allow")}
                              check={
                                ecoCommonConfigData?.noneWorkgroupPolicyDTO
                                  ?.policy?.drmPerm &&
                                ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy?.drmPerm?.indexOf(
                                  item.value
                                ) > -1
                              }
                              disable={pageType === "view"}
                              onClick={() => {
                                if (
                                  ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy?.drmPerm?.concat(
                                    item.value
                                  ) &&
                                  ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy?.drmPerm?.concat(
                                    item.value
                                  )?.length >= 4
                                ) {
                                  changeOpenExtraModal("RESTRICT_SELECT_ALL");
                                  return;
                                }
                                handleChangeConfigEdit(
                                  "ecoNoneworkgroupConfigPolicy",
                                  ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy?.drmPerm?.concat(
                                    item.value
                                  ),
                                  "drmPerm"
                                );
                              }}
                            />
                            <Radio
                              classes="mg ml-40"
                              label={t("admin.config.policy.notAllow")}
                              check={
                                ecoCommonConfigData?.noneWorkgroupPolicyDTO
                                  ?.policy?.drmPerm &&
                                ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy?.drmPerm?.indexOf(
                                  item.value
                                ) === -1
                              }
                              disable={pageType === "view"}
                              onClick={() => {
                                handleChangeConfigEdit(
                                  "ecoNoneworkgroupConfigPolicy",
                                  ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy?.drmPerm?.filter(
                                    (value) => value !== item.value
                                  ),
                                  "drmPerm"
                                );
                              }}
                            />
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  )}
                <Box classes="adminConfig-info-box">
                  <Box direction="column">
                    <Box>
                      <Typography type="subtitle2">
                        {t("admin.config.readRestrict.title")}
                      </Typography>
                      <Tooltip message={t("admin.config.readRestrict.tooltip")}>
                        <Icons
                          variant="fill"
                          label="questionmark"
                          classes="mg ml-4"
                        />
                      </Tooltip>
                    </Box>
                    <Typography
                      classes="mg mt-4"
                      type="body4_rg"
                      exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    >
                      {t("admin.config.readRestrict.subtitle")}
                    </Typography>
                  </Box>
                </Box>
                <Box classes="adminConfig-info-box">
                  <Checkbox
                    disable={pageType === "view"}
                    label={t("admin.config.policy.allowCount")}
                    check={
                      !!ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                        ?.allowViewCount &&
                      ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                        ?.allowViewCount > 0
                    }
                    onClick={() => {
                      handleChangeConfigEdit(
                        "ecoNoneworkgroupConfigPolicy",
                        ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                          ?.allowViewCount === 0
                          ? 20
                          : 0,
                        "allowViewCount"
                      );
                    }}
                  />
                  <Box alignItems="center">
                    {pageType === "view" && (
                      <Typography type="body2_rg">
                        {ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                          ?.allowViewCount === 0
                          ? t("admin.common.unlimited")
                          : ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                              ?.allowViewCount + t("admin.common.label.count")}
                      </Typography>
                    )}
                    {pageType === "edit" && (
                      <InputField
                        width={100}
                        placeholder={""}
                        maxLength={3}
                        value={
                          !!ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                            ?.allowViewCount &&
                          ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                            ?.allowViewCount > 0
                            ? ecoCommonConfigData?.noneWorkgroupPolicyDTO
                                ?.policy?.allowViewCount + ""
                            : ""
                        }
                        trailingIcon={t("admin.common.label.count")}
                        onChange={(e) => {
                          handleChangeConfigEdit(
                            "ecoNoneworkgroupConfigPolicy",
                            e.target.value ? parseInt(e.target.value) : 0,
                            "allowViewCount"
                          );
                        }}
                        disabled={
                          ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                            ?.allowViewCount === 0
                        }
                      />
                    )}
                  </Box>
                </Box>
                <Box classes="adminConfig-info-box">
                  <Checkbox
                    label={t("admin.config.policy.allowPeriod")}
                    check={
                      ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                        ?.allowDays !== undefined &&
                      ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                        ?.allowDays >= 0
                    }
                    disable={pageType === "view"}
                    onClick={() => {
                      handleChangeConfigEdit(
                        "ecoNoneworkgroupConfigPolicy",
                        ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                          ?.allowDays === -1
                          ? 60
                          : -1,
                        "allowDays"
                      );
                    }}
                  />
                  <Box direction="column">
                    <Box alignItems="center" justifyContent="flex-end">
                      {pageType === "view" && (
                        <Typography type="body2_rg">
                          {ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                            ?.allowDays === undefined ||
                          ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                            ?.allowDays === -1
                            ? t("file.policy.noDeadline")
                            : ecoCommonConfigData?.noneWorkgroupPolicyDTO
                                ?.policy?.allowDays +
                              t("admin.common.label.days")}
                        </Typography>
                      )}
                      {pageType === "edit" && (
                        <InputField
                          width={100}
                          placeholder={""}
                          maxLength={3}
                          value={
                            ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                              ?.allowDays === -1
                              ? ""
                              : ecoCommonConfigData?.noneWorkgroupPolicyDTO
                                  ?.policy?.allowDays + ""
                          }
                          trailingIcon={t("admin.common.label.days")}
                          onChange={(e) => {
                            handleChangeConfigEdit(
                              "ecoNoneworkgroupConfigPolicy",
                              e.target.value ? parseInt(e.target.value) : 0,
                              "allowDays"
                            );
                          }}
                          disabled={
                            ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                              ?.allowDays === -1
                          }
                        />
                      )}
                    </Box>
                    <Typography
                      type="body4_rg"
                      exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    >
                      ({t("admin.config.policy.dependDate")})
                    </Typography>
                  </Box>
                </Box>
                <Box classes="adminConfig-info-box">
                  <Box direction="column">
                    <Typography type="subtitle2">
                      {t("admin.config.webSetting.title")}
                    </Typography>
                    <Typography
                      classes="mg mt-4"
                      type="body4_rg"
                      exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    >
                      {t("admin.config.webSetting.subtitle")}
                    </Typography>
                  </Box>
                  {utilsCommon.checkSupportPolicy("Web", true) ===
                  "SUPPORT_ACCEPTED" ? (
                    <Toggle
                      disabled={pageType === "view"}
                      checked={
                        ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                          ?.webView
                      }
                      onChange={() => {
                        handleChangeConfigEdit(
                          "ecoNoneworkgroupConfigPolicy",
                          !ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                            ?.webView,
                          "webView"
                        );
                      }}
                    />
                  ) : utilsCommon.checkSupportPolicy("Web", true) ===
                    "ADMIN_NOT_ALLOW" ? (
                    <Box
                      justifyContent={"flex-end"}
                      classes={"not-support-webDesc"}
                    >
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.config.notPolicy")}
                      </Typography>
                    </Box>
                  ) : (
                    <Box
                      justifyContent={"flex-end"}
                      classes={"not-support-webDesc"}
                    >
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.config.notsupport")}
                      </Typography>
                    </Box>
                  )}
                </Box>
                {ecoCommonConfigData?.noneWorkgroupPolicyDTO?.policy
                  ?.webView && (
                  <Box classes="adminConfig-info-box" direction="column">
                    <Box justifyContent="flex-start" width={"100%"}>
                      <Checkbox
                        label={t("admin.config.webSetting.screenWatermark")}
                        disable
                        check={ecoCommonConfigData?.watermark !== "NONE"}
                      />
                    </Box>
                    <Box classes={"adminConfig-info-colorBox mg mt-12"}>
                      <Tooltip
                        message={
                          showScreenWaterMark().trim().endsWith("/")
                            ? showScreenWaterMark() +
                              t("admin.whiteLabel.siteName")
                            : showScreenWaterMark()
                        }
                      >
                        <Typography type="body3_rg">
                          {showScreenWaterMark().trim().endsWith("/")
                            ? showScreenWaterMark() +
                              t("admin.whiteLabel.siteName")
                            : showScreenWaterMark()}
                        </Typography>
                      </Tooltip>
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      )}
      {tab === 2 && (
        <Box classes="adminConfig-tab mg mt-12" direction="column">
          {ecoCommonConfigData.serviceType === "ONPREMISE" && (
            <Box direction="row">
              <Box classes="adminConfig-subject">
                <Typography
                  type="subtitle2"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.config.unWrap")}
                </Typography>
              </Box>
              <Box classes="adminConfig-info">
                {pageType === "view" && (
                  <Typography type="body2_rg">
                    {convertConfigUnWrapping(
                      ecoCommonConfigData.unwrappingPermission
                    )}
                  </Typography>
                )}
                {pageType === "edit" && (
                  <Box direction="row">
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        check={
                          ecoCommonConfigData.unwrappingPermission === "ALL"
                        }
                        label={convertConfigUnWrapping("ALL")}
                        onClick={() =>
                          handleChangeConfigEdit("unwrappingPermission", "ALL")
                        }
                      />
                    </Box>
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        check={
                          ecoCommonConfigData.unwrappingPermission ===
                          "INTERNAL_USER"
                        }
                        label={convertConfigUnWrapping("INTERNAL_USER")}
                        onClick={() =>
                          handleChangeConfigEdit(
                            "unwrappingPermission",
                            "INTERNAL_USER"
                          )
                        }
                      />
                    </Box>
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        check={
                          ecoCommonConfigData.unwrappingPermission === "MASTER"
                        }
                        label={convertConfigUnWrapping("MASTER")}
                        onClick={() =>
                          handleChangeConfigEdit(
                            "unwrappingPermission",
                            "MASTER"
                          )
                        }
                      />
                    </Box>
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        check={
                          ecoCommonConfigData.unwrappingPermission === "NONE"
                        }
                        label={convertConfigUnWrapping("NONE")}
                        onClick={() =>
                          handleChangeConfigEdit("unwrappingPermission", "NONE")
                        }
                      />
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          )}
          <Box direction="row">
            <Box classes="adminConfig-subject">
              <Typography
                type="subtitle2"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.config.workgroupCreatePermission")}
              </Typography>
            </Box>
            <Box classes="adminConfig-info">
              {pageType === "view" && (
                <Typography type="body2_rg">
                  {ecoCommonConfigData.workgroupCreatePermission === "ADMIN" ? (
                    <div>{t("admin.filter.userAdmin")}</div>
                  ) : ecoCommonConfigData.workgroupCreatePermission ===
                    "INTERNAL" ? (
                    <div>
                      {t("admin.filter.userAdmin") +
                        " / " +
                        t("admin.dept.internalUser")}
                    </div>
                  ) : ecoCommonConfigData.workgroupCreatePermission ===
                    "EXTERNAL" ? (
                    <div>
                      {t("admin.filter.userAdmin") +
                        " / " +
                        t("admin.dept.internalUser") +
                        " / " +
                        t("admin.dept.externalUser")}
                    </div>
                  ) : (
                    ""
                  )}
                </Typography>
              )}
              {pageType === "edit" && (
                <Box direction="row">
                  <Box minWidth={"25%"} classes="mg mr-8">
                    <Checkbox
                      label={t("admin.filter.userAdmin")}
                      check
                      disable
                    />
                  </Box>
                  <Box minWidth={"25%"} classes="mg mr-8">
                    <Checkbox
                      label={t("admin.dept.internalUser")}
                      check={
                        ecoCommonConfigData.workgroupCreatePermission ===
                        "INTERNAL"
                      }
                      onClick={() => {
                        handleChangeConfigEdit(
                          "workgroupCreatePermission",
                          ecoCommonConfigData.workgroupCreatePermission ===
                            "INTERNAL"
                            ? "ADMIN"
                            : "INTERNAL"
                        );
                      }}
                    />
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
          <Box direction="row">
            <Box classes="adminConfig-subject">
              <Typography
                type="subtitle2"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.config.workgroupHeadSelectPermission")}
              </Typography>
            </Box>
            <Box classes="adminConfig-info">
              {pageType === "view" && (
                <Typography type="body2_rg">
                  {ecoCommonConfigData.workgroupHeadSelectPermission ===
                  "@@WORKGROUPCREATOR"
                    ? t("admin.config.workgroupCreator")
                    : ecoCommonConfigData.workgroupHeadSelectPermission &&
                      t("admin.filter.userAdmin") +
                        "(" +
                        ecoCommonConfigData.workgroupHeadSelectPermission +
                        ")"}
                </Typography>
              )}
              {pageType === "edit" && (
                <Box direction="row">
                  <Box minWidth={"25%"} classes="mg mr-8">
                    <Radio
                      check={
                        ecoCommonConfigData.workgroupHeadSelectPermission ===
                        "@@WORKGROUPCREATOR"
                      }
                      label={t("admin.config.workgroupCreator")}
                      onClick={() =>
                        handleChangeConfigEdit(
                          "workgroupHeadSelectPermission",
                          "@@WORKGROUPCREATOR"
                        )
                      }
                    />
                  </Box>
                  <Box minWidth={"25%"} classes="mg mr-8">
                    <Radio
                      check={
                        ecoCommonConfigData.workgroupHeadSelectPermission !==
                        "@@WORKGROUPCREATOR"
                      }
                      label={t("admin.filter.userAdmin")}
                      onClick={() =>
                        handleChangeConfigEdit(
                          "workgroupHeadSelectPermission",
                          window.eco.serviceType === "OCI"
                            ? myId
                            : assignmentList[0].adminId
                        )
                      }
                    />
                    <Dropdown
                      classes="mg ml-16"
                      btnSize="sm"
                      placeholder=" "
                      width={160}
                      buttonClick={buttonClick}
                      disabled={
                        ecoCommonConfigData.workgroupHeadSelectPermission ===
                          "@@WORKGROUPCREATOR" ||
                        (window.eco.serviceType === "OCI"
                          ? [{ adminId: myId }]
                          : assignmentList
                        ).length === 1
                      }
                      value={
                        ecoCommonConfigData.workgroupHeadSelectPermission ===
                        "@@WORKGROUPCREATOR"
                          ? window.eco.serviceType === "OCI"
                            ? myId
                            : assignmentList[0].adminId
                          : ecoCommonConfigData.workgroupHeadSelectPermission
                      }
                    >
                      {(window.eco.serviceType === "OCI"
                        ? [{ adminId: myId }]
                        : assignmentList
                      ).map((item) => (
                        <DropdownItem
                          label={item.adminId}
                          onClick={() => {
                            handleChangeConfigEdit(
                              "workgroupHeadSelectPermission",
                              item.adminId
                            );
                            changeButtonClick(buttonClick + 1);
                          }}
                        />
                      ))}
                    </Dropdown>
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
          <Box direction="row">
            <Box classes="adminConfig-subject">
              <Typography
                type="subtitle2"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.config.autoUnwrappingPermission")}
              </Typography>
            </Box>
            <Box classes="adminConfig-info">
              {pageType === "view" && (
                <Typography type="body2_rg">
                  {ecoCommonConfigData.autoUnwrappingPermission
                    ? t("admin.config.policy.active")
                    : t("admin.config.policy.inActive")}
                </Typography>
              )}
              {pageType === "edit" && (
                <Box direction="row">
                  <Box minWidth={"25%"} classes="mg mr-8">
                    <Radio
                      check={ecoCommonConfigData.autoUnwrappingPermission}
                      label={t("admin.config.policy.active")}
                      onClick={() =>
                        handleChangeConfigEdit("autoUnwrappingPermission", true)
                      }
                    />
                  </Box>
                  <Box minWidth={"25%"} classes="mg mr-8">
                    <Radio
                      check={!ecoCommonConfigData.autoUnwrappingPermission}
                      label={t("admin.config.policy.inActive")}
                      onClick={() =>
                        handleChangeConfigEdit(
                          "autoUnwrappingPermission",
                          false
                        )
                      }
                    />
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
          <Box direction="row">
            <Box classes="adminConfig-subject">
              <Typography
                type="subtitle2"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.config.nestedWorkgroup")}
              </Typography>
            </Box>
            <Box classes="adminConfig-info" direction="column">
              {pageType === "view" ? (
                <Typography type="body2_rg">
                  {ecoCommonConfigData.workgroupTreeViewPermission === "ALL"
                    ? t("admin.config.toAll")
                    : ecoCommonConfigData.workgroupTreeViewPermission ===
                      "INTERNAL_USER"
                    ? t("admin.config.toInternal")
                    : t("admin.config.toNone")}
                  {ecoCommonConfigData.workgroupTreeCreatePermission ===
                    "INTERNAL_USER" &&
                    ` (${t("admin.config.allowInternalSub")})`}
                </Typography>
              ) : (
                <Box direction="column">
                  <Box direction="row">
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        check={
                          ecoCommonConfigTemp.workgroupTreeViewPermission ===
                          "ALL"
                        }
                        label={t("admin.config.toAll")}
                        onClick={() =>
                          handleChangeConfigEdit(
                            "workgroupTreeViewPermission",
                            "ALL"
                          )
                        }
                      />
                    </Box>
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        check={
                          ecoCommonConfigTemp.workgroupTreeViewPermission ===
                          "INTERNAL_USER"
                        }
                        label={t("admin.config.toInternal")}
                        onClick={() =>
                          handleChangeConfigEdit(
                            "workgroupTreeViewPermission",
                            "INTERNAL_USER"
                          )
                        }
                      />
                    </Box>
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        check={
                          ecoCommonConfigTemp.workgroupTreeViewPermission ===
                          "NONE"
                        }
                        label={t("admin.config.toNone")}
                        onClick={() =>
                          handleChangeConfigEdit(
                            "workgroupTreeViewPermission",
                            "NONE"
                          )
                        }
                      />
                    </Box>
                  </Box>
                  <Box classes="mg mt-16 adminConfig-graybox">
                    <Checkbox
                      disable={
                        ecoCommonConfigTemp.workgroupTreeViewPermission ===
                        "NONE"
                      }
                      check={
                        ecoCommonConfigTemp.workgroupTreeCreatePermission ===
                        "INTERNAL_USER"
                      }
                      onClick={() =>
                        handleChangeConfigEdit(
                          "workgroupTreeCreatePermission",
                          ecoCommonConfigTemp.workgroupTreeCreatePermission ===
                            "INTERNAL_USER"
                            ? "MASTER"
                            : "INTERNAL_USER"
                        )
                      }
                    />
                    <Typography
                      type="body2_rg"
                      classes="mg ml-8"
                      exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    >
                      {t("admin.config.allowInternalSub")}
                    </Typography>
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
          <Box direction="row">
            <Box classes="adminConfig-subject">
              <Typography
                type="subtitle2"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.config.moveFileAuth")}
              </Typography>
            </Box>
            <Box classes="adminConfig-info">
              {pageType === "view" && (
                <Typography type="body2_rg">
                  {ecoCommonConfigData.folderMoveAllowType
                    ? ecoCommonConfigData.folderMoveAllowType === "ALL"
                      ? t("admin.config.restorePermissionAll")
                      : ecoCommonConfigData.folderMoveAllowType ===
                        "INTERNAL_USER"
                      ? t("admin.config.internalUserOnly")
                      : ecoCommonConfigData.folderMoveAllowType === "MASTER"
                      ? t("admin.config.activeFileMaster")
                      : ecoCommonConfigData.unwrappingPermission === "NONE"
                    : !ecoCommonConfigData?.folderMoveOwner
                    ? t("admin.config.restorePermissionAll")
                    : t("admin.config.activeFileMaster")}
                </Typography>
              )}
              {pageType === "edit" && (
                <Box direction="row">
                  <Box minWidth={"25%"} classes="mg mr-8">
                    <Radio
                      check={ecoCommonConfigData.folderMoveAllowType === "ALL"}
                      label={t("admin.config.restorePermissionAll")}
                      onClick={() =>
                        handleChangeConfigEdit("folderMoveAllowType", "ALL")
                      }
                    />
                  </Box>
                  <Box minWidth={"25%"} classes="mg mr-8">
                    <Radio
                      check={
                        ecoCommonConfigData.folderMoveAllowType === "MASTER"
                      }
                      label={t("admin.config.activeFileMaster")}
                      onClick={() =>
                        handleChangeConfigEdit("folderMoveAllowType", "MASTER")
                      }
                    />
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
          {!window.eco.isOnlyVerifiedLinkAllowed && (
            <Box direction="row">
              <Box classes="adminConfig-subject">
                <Typography
                  type="subtitle2"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.config.shareLinkDefault")}
                </Typography>
              </Box>
              <Box classes="adminConfig-info">
                {checkFileShareLink("workgroup")}
              </Box>
            </Box>
          )}
          <Box direction="row">
            <Box classes="adminConfig-subject">
              <Typography
                type="subtitle2"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.config.workgroupDefault")}
              </Typography>
            </Box>
            <Box classes="adminConfig-info">
              <Box direction="column">
                <Box classes="adminConfig-info-box">
                  <Box direction="column">
                    <Typography type="subtitle2">
                      {t("admin.config.editFile.title")}
                    </Typography>
                    <Typography
                      classes="mg mt-4"
                      type="body4_rg"
                      exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    >
                      {t("admin.config.editFile.subtitle")}
                    </Typography>
                  </Box>
                  <Toggle
                    disabled={pageType === "view"}
                    checked={
                      ecoCommonConfigData?.workgroupPermissionDTO?.policy
                        ?.revision
                    }
                    onChange={() => {
                      handleChangeConfigEdit(
                        "ecoCommonConfigPolicy",
                        !ecoCommonConfigData?.workgroupPermissionDTO?.policy
                          ?.revision,
                        "revision"
                      );
                    }}
                  />
                </Box>
                <Box classes="adminConfig-info-box">
                  <Box direction="column">
                    <Box>
                      <Typography type="subtitle2">
                        {t("admin.config.downloadFile.title")}
                      </Typography>
                      <Tooltip message={t("admin.config.downloadFile.tooltip")}>
                        <Icons
                          variant="fill"
                          label="questionmark"
                          classes="mg ml-4"
                        />
                      </Tooltip>
                    </Box>
                    <Typography
                      classes="mg mt-4"
                      type="body4_rg"
                      exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    >
                      {t("admin.config.downloadFile.subtitle")}
                    </Typography>
                  </Box>
                  <Toggle
                    disabled={pageType === "view"}
                    checked={
                      ecoCommonConfigData?.workgroupPermissionDTO?.policy
                        ?.download
                    }
                    onChange={() => {
                      handleChangeConfigEdit(
                        "ecoCommonConfigPolicy",
                        !ecoCommonConfigData?.workgroupPermissionDTO?.policy
                          ?.download,
                        "download"
                      );
                    }}
                  />
                </Box>
                {ecoCommonConfigData?.workgroupPermissionDTO?.policy
                  ?.download && (
                  <Box classes="adminConfig-info-box mg mt-20">
                    <Box
                      direction="column"
                      width={
                        ecoCommonConfigData?.workgroupPermissionDTO?.policy
                          ?.wrapping
                          ? "calc(100% - 148px)"
                          : "100%"
                      }
                    >
                      <Box alignItems="center">
                        <Checkbox
                          disable={pageType === "view"}
                          label={t("admin.config.advancedSecurity.title")}
                          check={
                            ecoCommonConfigData?.workgroupPermissionDTO?.policy
                              ?.wrapping
                          }
                          onClick={() => {
                            handleChangeConfigEdit(
                              "ecoCommonConfigPolicy",
                              !ecoCommonConfigData?.workgroupPermissionDTO
                                ?.policy?.wrapping,
                              "wrapping"
                            );
                          }}
                        />
                        <Tooltip
                          message={t(
                            "admin.config.advancedSecurity.noApplyMac"
                          )}
                        >
                          <Icons
                            variant="fill"
                            label="questionmark"
                            classes="mg ml-4 mt-4"
                          />
                        </Tooltip>
                      </Box>
                      <Tooltip
                        message={`${t(
                          "admin.config.advancedSecurity.extensions"
                        )}: ${[
                          ...new Set([
                            ...(utilsCommon.getServiceConfig(
                              true,
                              "revisionExtensions"
                            ) || []),
                            ...(utilsCommon.getServiceConfig(
                              true,
                              "manualRevisionExtensions"
                            ) || []),
                          ]),
                        ]
                          .filter((ext) => !!ext)
                          .map((ext) => ext)
                          .sort((a, b) => (a < b ? -1 : 1))
                          .join(", ")}`}
                      >
                        <Typography
                          ellipsis
                          classes="mg ml-28"
                          type="body4_rg"
                          exactColor={getColor("COLOR_TEXT_SECONDARY")}
                        >
                          {t("admin.config.advancedSecurity.extensions")}:{" "}
                          {[
                            ...new Set([
                              ...(utilsCommon.getServiceConfig(
                                true,
                                "revisionExtensions"
                              ) || []),
                              ...(utilsCommon.getServiceConfig(
                                true,
                                "manualRevisionExtensions"
                              ) || []),
                            ]),
                          ]
                            .filter((ext) => !!ext)
                            .map((ext) => ext)
                            .sort((a, b) => (a < b ? -1 : 1))
                            .join(", ")}
                        </Typography>
                      </Tooltip>
                    </Box>
                    {ecoCommonConfigData?.workgroupPermissionDTO?.policy
                      ?.wrapping &&
                      pageType === "view" && (
                        <Typography type="body2_rg">
                          {ecoCommonConfigData?.workgroupPermissionDTO?.policy
                            ?.wrapping &&
                          ecoCommonConfigData?.workgroupPermissionDTO?.policy
                            ?.drmPerm?.length === 0
                            ? t("admin.config.advancedSecurity.normal")
                            : t("admin.config.advancedSecurity.advanced")}
                        </Typography>
                      )}
                    {ecoCommonConfigData?.workgroupPermissionDTO?.policy
                      ?.wrapping &&
                      pageType === "edit" && (
                        <Dropdown
                          classes="mg ml-16"
                          btnSize="sm"
                          placeholder=" "
                          width={160}
                          buttonClick={buttonClick}
                          value={
                            ecoCommonConfigData?.workgroupPermissionDTO?.policy
                              ?.wrapping &&
                            ecoCommonConfigData?.workgroupPermissionDTO?.policy
                              ?.drmPerm?.length === 0
                              ? t("admin.config.advancedSecurity.normal")
                              : t("admin.config.advancedSecurity.advanced")
                          }
                        >
                          <DropdownItem
                            label={t("admin.config.advancedSecurity.normal")}
                            onClick={() => {
                              handleChangeConfigEdit(
                                "ecoCommonConfigPolicy",
                                [],
                                "drmPerm"
                              );
                              changeButtonClick(buttonClick + 1);
                            }}
                          />
                          <DropdownItem
                            label={t("admin.config.advancedSecurity.advanced")}
                            onClick={() => {
                              handleChangeConfigEdit(
                                "ecoCommonConfigPolicy",
                                ["view"],
                                "drmPerm"
                              );
                              changeButtonClick(buttonClick + 1);
                            }}
                          />
                        </Dropdown>
                      )}
                  </Box>
                )}

                {ecoCommonConfigData?.workgroupPermissionDTO?.policy
                  ?.download &&
                  ecoCommonConfigData?.workgroupPermissionDTO?.policy
                    ?.drmPerm &&
                  ecoCommonConfigData?.workgroupPermissionDTO?.policy
                    ?.wrapping &&
                  ecoCommonConfigData?.workgroupPermissionDTO?.policy?.drmPerm
                    ?.length > 0 && (
                    <Box classes="adminConfig-info-colorBox mg mt-32">
                      {[
                        {
                          title: t("admin.config.advancedSecurity.print"),
                          value: "print",
                        },
                        {
                          title: t("admin.config.advancedSecurity.printScreen"),
                          value: "print_screen",
                        },
                        {
                          title: t("admin.config.advancedSecurity.copyDoc"),
                          value: "extract",
                        },
                      ].map((item, index) => (
                        <Box
                          justifyContent="space-between"
                          width={"100%"}
                          classes={index > 0 ? "mg mt-16" : ""}
                        >
                          <Typography
                            type="body2_rg"
                            exactColor={getColor("COLOR_TEXT_SECONDARY")}
                          >
                            {item.title}
                          </Typography>
                          <Box classes="radioGroups">
                            <Radio
                              label={t("admin.config.policy.allow")}
                              check={
                                ecoCommonConfigData?.workgroupPermissionDTO
                                  ?.policy?.drmPerm &&
                                ecoCommonConfigData?.workgroupPermissionDTO?.policy?.drmPerm?.indexOf(
                                  item.value
                                ) > -1
                              }
                              disable={pageType === "view"}
                              onClick={() => {
                                if (
                                  ecoCommonConfigData?.workgroupPermissionDTO?.policy?.drmPerm?.concat(
                                    item.value
                                  ) &&
                                  ecoCommonConfigData?.workgroupPermissionDTO?.policy?.drmPerm?.concat(
                                    item.value
                                  )?.length >= 4
                                ) {
                                  changeOpenExtraModal("RESTRICT_SELECT_ALL");
                                  return;
                                }
                                handleChangeConfigEdit(
                                  "ecoCommonConfigPolicy",
                                  ecoCommonConfigData?.workgroupPermissionDTO?.policy?.drmPerm?.concat(
                                    item.value
                                  ),
                                  "drmPerm"
                                );
                              }}
                            />
                            <Radio
                              classes="mg ml-40"
                              label={t("admin.config.policy.notAllow")}
                              check={
                                ecoCommonConfigData?.workgroupPermissionDTO
                                  ?.policy?.drmPerm &&
                                ecoCommonConfigData?.workgroupPermissionDTO?.policy?.drmPerm?.indexOf(
                                  item.value
                                ) === -1
                              }
                              disable={pageType === "view"}
                              onClick={() => {
                                handleChangeConfigEdit(
                                  "ecoCommonConfigPolicy",
                                  ecoCommonConfigData?.workgroupPermissionDTO?.policy?.drmPerm?.filter(
                                    (value) => value !== item.value
                                  ),
                                  "drmPerm"
                                );
                              }}
                            />
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  )}
                <Box classes="adminConfig-info-box">
                  <Box direction="column">
                    <Box>
                      <Typography type="subtitle2">
                        {t("admin.config.readRestrict.title")}
                      </Typography>
                      <Tooltip message={t("admin.config.readRestrict.tooltip")}>
                        <Icons
                          variant="fill"
                          label="questionmark"
                          classes="mg ml-4"
                        />
                      </Tooltip>
                    </Box>
                    <Typography
                      classes="mg mt-4"
                      type="body4_rg"
                      exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    >
                      {t("admin.config.readRestrict.subtitle")}
                    </Typography>
                  </Box>
                </Box>
                <Box classes="adminConfig-info-box">
                  <Checkbox
                    disable={pageType === "view"}
                    label={t("admin.config.policy.allowCount")}
                    check={
                      !!ecoCommonConfigData?.workgroupPermissionDTO?.policy
                        ?.allowViewCount &&
                      ecoCommonConfigData?.workgroupPermissionDTO?.policy
                        ?.allowViewCount > 0
                    }
                    onClick={() => {
                      handleChangeConfigEdit(
                        "ecoCommonConfigPolicy",
                        ecoCommonConfigData?.workgroupPermissionDTO?.policy
                          ?.allowViewCount === 0
                          ? 20
                          : 0,
                        "allowViewCount"
                      );
                    }}
                  />
                  <Box alignItems="center">
                    {pageType === "view" && (
                      <Typography type="body2_rg">
                        {ecoCommonConfigData?.workgroupPermissionDTO?.policy
                          ?.allowViewCount === 0
                          ? t("admin.common.unlimited")
                          : ecoCommonConfigData?.workgroupPermissionDTO?.policy
                              ?.allowViewCount + t("admin.common.label.count")}
                      </Typography>
                    )}
                    {pageType === "edit" && (
                      <InputField
                        width={100}
                        placeholder={""}
                        maxLength={3}
                        value={
                          !!ecoCommonConfigData?.workgroupPermissionDTO?.policy
                            ?.allowViewCount &&
                          ecoCommonConfigData?.workgroupPermissionDTO?.policy
                            ?.allowViewCount > 0
                            ? ecoCommonConfigData?.workgroupPermissionDTO
                                ?.policy?.allowViewCount + ""
                            : ""
                        }
                        trailingIcon={t("admin.common.label.count")}
                        onChange={(e) => {
                          handleChangeConfigEdit(
                            "ecoCommonConfigPolicy",
                            e.target.value ? parseInt(e.target.value) : 0,
                            "allowViewCount"
                          );
                        }}
                        disabled={
                          ecoCommonConfigData?.workgroupPermissionDTO?.policy
                            ?.allowViewCount === 0
                        }
                      />
                    )}
                  </Box>
                </Box>
                <Box classes="adminConfig-info-box">
                  <Checkbox
                    label={t("admin.config.policy.allowPeriod")}
                    check={
                      ecoCommonConfigData?.workgroupPermissionDTO?.policy
                        ?.allowDays !== undefined &&
                      ecoCommonConfigData?.workgroupPermissionDTO?.policy
                        ?.allowDays >= 0
                    }
                    disable={pageType === "view"}
                    onClick={() => {
                      handleChangeConfigEdit(
                        "ecoCommonConfigPolicy",
                        ecoCommonConfigData?.workgroupPermissionDTO?.policy
                          ?.allowDays === -1
                          ? 60
                          : -1,
                        "allowDays"
                      );
                    }}
                  />
                  <Box direction="column">
                    <Box alignItems="center" justifyContent="flex-end">
                      {pageType === "view" && (
                        <Typography type="body2_rg">
                          {ecoCommonConfigData?.workgroupPermissionDTO?.policy
                            ?.allowDays === undefined ||
                          ecoCommonConfigData?.workgroupPermissionDTO?.policy
                            ?.allowDays === -1
                            ? t("file.policy.noDeadline")
                            : ecoCommonConfigData?.workgroupPermissionDTO
                                ?.policy?.allowDays +
                              t("admin.common.label.days")}
                        </Typography>
                      )}
                      {pageType === "edit" && (
                        <InputField
                          width={100}
                          placeholder={""}
                          maxLength={3}
                          value={
                            ecoCommonConfigData?.workgroupPermissionDTO?.policy
                              ?.allowDays === -1
                              ? ""
                              : ecoCommonConfigData?.workgroupPermissionDTO
                                  ?.policy?.allowDays + ""
                          }
                          trailingIcon={t("admin.common.label.days")}
                          onChange={(e) => {
                            handleChangeConfigEdit(
                              "ecoCommonConfigPolicy",
                              e.target.value ? parseInt(e.target.value) : 0,
                              "allowDays"
                            );
                          }}
                          disabled={
                            ecoCommonConfigData?.workgroupPermissionDTO?.policy
                              ?.allowDays === -1
                          }
                        />
                      )}
                    </Box>
                    <Typography
                      type="body4_rg"
                      exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    >
                      ({t("admin.config.policy.dependDate")})
                    </Typography>
                  </Box>
                </Box>
                <Box classes="adminConfig-info-box">
                  <Box direction="column">
                    <Typography type="subtitle2">
                      {t("admin.config.webSetting.title")}
                    </Typography>
                    <Typography
                      classes="mg mt-4"
                      type="body4_rg"
                      exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    >
                      {t("admin.config.webSetting.subtitle")}
                    </Typography>
                  </Box>
                  {utilsCommon.checkSupportPolicy("Web", true) ===
                  "SUPPORT_ACCEPTED" ? (
                    <Toggle
                      disabled={pageType === "view"}
                      checked={
                        ecoCommonConfigData?.workgroupPermissionDTO?.policy
                          ?.webView
                      }
                      onChange={() => {
                        handleChangeConfigEdit(
                          "ecoCommonConfigPolicy",
                          !ecoCommonConfigData?.workgroupPermissionDTO?.policy
                            ?.webView,
                          "webView"
                        );
                      }}
                    />
                  ) : utilsCommon.checkSupportPolicy("Web", true) ===
                    "ADMIN_NOT_ALLOW" ? (
                    <Box
                      justifyContent={"flex-end"}
                      classes={"not-support-webDesc"}
                    >
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.config.notPolicy")}
                      </Typography>
                    </Box>
                  ) : (
                    <Box
                      justifyContent={"flex-end"}
                      classes={"not-support-webDesc"}
                    >
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.config.notsupport")}
                      </Typography>
                    </Box>
                  )}
                </Box>
                {ecoCommonConfigData?.workgroupPermissionDTO?.policy
                  ?.webView && (
                  <Box classes="adminConfig-info-box" direction="column">
                    <Box justifyContent="flex-start" width={"100%"}>
                      <Checkbox
                        label={t("admin.config.webSetting.screenWatermark")}
                        disable
                        check={ecoCommonConfigData?.watermark !== "NONE"}
                      />
                    </Box>
                    <Box classes={"adminConfig-info-colorBox mg mt-12"}>
                      <Tooltip
                        message={
                          showScreenWaterMark().trim().endsWith("/")
                            ? showScreenWaterMark() +
                              t("admin.whiteLabel.siteName")
                            : showScreenWaterMark()
                        }
                      >
                        <Typography type="body3_rg">
                          {showScreenWaterMark().trim().endsWith("/")
                            ? showScreenWaterMark() +
                              t("admin.whiteLabel.siteName")
                            : showScreenWaterMark()}
                        </Typography>
                      </Tooltip>
                    </Box>
                  </Box>
                )}
                <Box classes="adminConfig-info-box">
                  <Box direction="column">
                    <Typography type="subtitle2">
                      {t("admin.config.mobileSetting.title")}
                    </Typography>
                    <Typography
                      classes="mg mt-4"
                      type="body4_rg"
                      exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    >
                      {t("admin.config.mobileSetting.subtitle")}
                    </Typography>
                  </Box>
                  {utilsCommon.checkSupportPolicy("Mobile", true) ===
                  "SUPPORT_ACCEPTED" ? (
                    <Toggle disabled={true} checked={true} />
                  ) : utilsCommon.checkSupportPolicy("Mobile", true) ===
                    "ADMIN_NOT_ALLOW" ? (
                    <Box
                      justifyContent={"flex-end"}
                      classes={"not-support-webDesc"}
                    >
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.config.notPolicy")}
                      </Typography>
                    </Box>
                  ) : (
                    <Box
                      justifyContent={"flex-end"}
                      classes={"not-support-webDesc"}
                    >
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.config.notsupport")}
                      </Typography>
                    </Box>
                  )}
                </Box>
                <Box classes="adminConfig-info-box">
                  <Box direction="column">
                    <Typography type="subtitle2">
                      {t("admin.config.macSetting.title")}
                    </Typography>
                    <Typography
                      classes="mg mt-4"
                      type="body4_rg"
                      exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    >
                      {t("admin.config.macSetting.subtitle")}
                    </Typography>
                  </Box>
                  {utilsCommon.checkSupportPolicy("Mac", true) ===
                  "SUPPORT_ACCEPTED" ? (
                    <Toggle disabled={true} checked={true} />
                  ) : utilsCommon.checkSupportPolicy("Mac", true) ===
                    "ADMIN_NOT_ALLOW" ? (
                    <Box
                      justifyContent={"flex-end"}
                      classes={"not-support-webDesc"}
                    >
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.config.notPolicy")}
                      </Typography>
                    </Box>
                  ) : (
                    <Box
                      justifyContent={"flex-end"}
                      classes={"not-support-webDesc"}
                    >
                      <Typography
                        type="body2_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.config.notsupport")}
                      </Typography>
                    </Box>
                  )}
                </Box>
                {ecoCommonConfigData.serviceType !== "OCI" && (
                  <Box classes="adminConfig-info-box">
                    <Box direction="column">
                      <Box>
                        <Typography type="subtitle2">
                          {t("admin.config.openSetting.title")}
                        </Typography>
                      </Box>
                      <Typography
                        classes="mg mt-4"
                        type="body4_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {t("admin.config.openSetting.subtitle")}
                      </Typography>
                    </Box>
                    <Toggle
                      disabled={pageType === "view"}
                      checked={
                        ecoCommonConfigData?.workgroupPermissionDTO?.policy
                          ?.additionalViewPermission === "INTERNAL_USER"
                      }
                      onChange={() => {
                        handleChangeConfigEdit(
                          "ecoCommonConfigPolicy",
                          ecoCommonConfigData?.workgroupPermissionDTO?.policy
                            ?.additionalViewPermission === "INTERNAL_USER"
                            ? "NONE"
                            : "INTERNAL_USER",
                          "additionalViewPermission"
                        );
                      }}
                    />
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      )}
      {tab === 3 && (
        <Box classes="adminConfig-tab mg mt-12" direction="column">
          <Box direction="row">
            <Box classes="adminConfig-subject">
              <Typography
                type="subtitle2"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.config.alarm.workgroupAlarm")}
              </Typography>
            </Box>
            <Box classes="adminConfig-info">
              {ecoCommonConfigData && (
                <WorkgroupAlarmPage
                  type={pageType}
                  ecoCommonConfig={ecoCommonConfigData}
                  setEcoCommonConfig={setEcoCommonConfigTemp}
                />
              )}
            </Box>
          </Box>
        </Box>
      )}
      {tab === 4 && (
        <Box classes="adminConfig-tab mg mt-12" direction="column">
          <Box direction="row">
            <Box classes="adminConfig-subject">
              <Typography
                type="subtitle2"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.config.activeHtmlWrapping")}
              </Typography>
            </Box>
            <Box classes="adminConfig-info">
              <Box direction="row">
                <Box minWidth={"25%"} classes="mg mr-8">
                  <Radio
                    disable={pageType === "view"}
                    check={ecoCommonConfigData.activeHtmlWrapping}
                    label={"HTML"}
                    onClick={() =>
                      handleChangeConfigEdit("activeHtmlWrapping", true)
                    }
                  />
                </Box>
                <Box minWidth={"25%"} classes="mg mr-8">
                  <Radio
                    disable={pageType === "view"}
                    check={!ecoCommonConfigData.activeHtmlWrapping}
                    label={"Wrapsody eCo"}
                    onClick={() =>
                      handleChangeConfigEdit("activeHtmlWrapping", false)
                    }
                  />
                </Box>
              </Box>
            </Box>
          </Box>
          {window.eco.serviceType !== "OCI" && (
            <Box direction="row">
              <Box classes="adminConfig-subject">
                <Typography
                  type="subtitle2"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.config.passwordLength")}
                </Typography>
              </Box>
              <Box classes="adminConfig-info">
                {pageType === "view" ? (
                  <Typography type="body2_md">
                    {t("admin.config.passwordLengthView", {
                      minLength:
                        ecoCommonConfig.passwordPolicyDTO?.minLength ?? 6,
                      maxLength:
                        ecoCommonConfig.passwordPolicyDTO?.maxLength ?? 30,
                    })}
                  </Typography>
                ) : (
                  <Box direction="column">
                    <Box alignItems="center">
                      <Typography classes="mg mr-8">
                        {t("admin.config.passwordLengthMin")}
                      </Typography>
                      <InputField
                        placeholder={"6"}
                        width={100}
                        size="md"
                        maxLength={2}
                        type="positive-integer"
                        value={
                          ecoCommonConfigTemp.passwordPolicyDTO?.minLength + ""
                        }
                        onChange={(e) =>
                          (!e.target.value || parseInt(e.target.value) <= 30) &&
                          setEcoCommonConfigTemp({
                            ...ecoCommonConfigTemp,
                            passwordPolicyDTO: {
                              minLength: e.target.value,
                              maxLength:
                                ecoCommonConfigTemp.passwordPolicyDTO
                                  ?.maxLength ?? 30,
                            },
                          })
                        }
                      />
                      <Typography classes="mg ml-8">
                        {t("admin.config.passwordLengthUnit")}
                      </Typography>
                      <Typography classes="mg ml-20 mr-8">
                        {t("admin.config.passwordLengthMax")}
                      </Typography>
                      <InputField
                        placeholder={"30"}
                        width={100}
                        size="md"
                        maxLength={2}
                        type="positive-integer"
                        value={
                          ecoCommonConfigTemp.passwordPolicyDTO?.maxLength + ""
                        }
                        onChange={(e) =>
                          (!e.target.value || parseInt(e.target.value) <= 30) &&
                          setEcoCommonConfigTemp({
                            ...ecoCommonConfigTemp,
                            passwordPolicyDTO: {
                              maxLength: e.target.value,
                              minLength:
                                ecoCommonConfigTemp.passwordPolicyDTO
                                  ?.minLength ?? 6,
                            },
                          })
                        }
                      />
                      <Typography classes="mg ml-8">
                        {t("admin.config.passwordLengthUnit")}
                      </Typography>
                    </Box>
                    <Typography
                      classes="mg mt-10"
                      type="body4_rg"
                      exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    >
                      {t("admin.config.passwordLengthRange")}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
          )}
          {ecoCommonConfigData.displayLiteExternalPolicy && (
            <Box direction="row">
              <Box classes="adminConfig-subject">
                <Typography
                  type="subtitle2"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.config.allowOTPUser")}
                </Typography>
              </Box>
              <Box classes="adminConfig-info">
                <Box direction="row">
                  <Box minWidth={"25%"} classes="mg mr-8">
                    <Radio
                      disable={pageType === "view"}
                      check={ecoCommonConfigData.allowLiteExternal}
                      label={t("admin.common.label.allow")}
                      onClick={() =>
                        handleChangeConfigEdit("allowLiteExternal", true)
                      }
                    />
                  </Box>
                  <Box minWidth={"25%"} classes="mg mr-8">
                    <Radio
                      disable={pageType === "view"}
                      check={!ecoCommonConfigData.allowLiteExternal}
                      label={t("admin.common.label.disallow")}
                      onClick={() =>
                        handleChangeConfigEdit("allowLiteExternal", false)
                      }
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
          {ecoCommonConfigData.serviceType !== "ONPREMISE" &&
            window.eco.serviceType !== "OCI" && (
              <Box direction="row">
                <Box classes="adminConfig-subject">
                  <Typography
                    type="subtitle2"
                    exactColor={getColor("COLOR_TEXT_SECONDARY")}
                  >
                    {t("admin.config.externalUserInfo")}
                  </Typography>
                </Box>
                <Box classes="adminConfig-info">
                  <Box direction="row">
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        disable={pageType === "view"}
                        check={
                          ecoCommonConfigData.externalUserViewType === "ALL"
                        }
                        label={convertConfigUser("ALL")}
                        onClick={() =>
                          handleChangeConfigEdit("externalUserViewType", "ALL")
                        }
                      />
                    </Box>
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        disable={pageType === "view"}
                        check={
                          ecoCommonConfigData.externalUserViewType === "MY_LIST"
                        }
                        label={convertConfigUser("MY_LIST")}
                        onClick={() =>
                          handleChangeConfigEdit(
                            "externalUserViewType",
                            "MY_LIST"
                          )
                        }
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            )}
          {ecoCommonConfigData.serviceType !== "ONPREMISE" &&
            window.eco.serviceType !== "OCI" && (
              <Box direction="row">
                <Box classes="adminConfig-subject">
                  <Typography
                    type="subtitle2"
                    exactColor={getColor("COLOR_TEXT_SECONDARY")}
                  >
                    {t("admin.config.fileEditor")}
                  </Typography>
                </Box>
                <Box classes="adminConfig-info">
                  <Box direction="row">
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        disable={pageType === "view"}
                        check={
                          ecoCommonConfigData.webOfficeAllowUserType === "DENY"
                        }
                        label={convertConfigEditor("DENY")}
                        onClick={() =>
                          handleChangeConfigEdit(
                            "webOfficeAllowUserType",
                            "DENY"
                          )
                        }
                      />
                    </Box>
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        disable={pageType === "view"}
                        check={
                          ecoCommonConfigData.webOfficeAllowUserType ===
                          "INTERNAL_USER"
                        }
                        label={convertConfigEditor("INTERNAL_USER")}
                        onClick={() =>
                          handleChangeConfigEdit(
                            "webOfficeAllowUserType",
                            "INTERNAL_USER"
                          )
                        }
                      />
                    </Box>
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        disable={pageType === "view"}
                        check={
                          ecoCommonConfigData.webOfficeAllowUserType === "ALL"
                        }
                        label={convertConfigEditor("ALL")}
                        onClick={() =>
                          handleChangeConfigEdit(
                            "webOfficeAllowUserType",
                            "ALL"
                          )
                        }
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            )}
          {userEcoSystemLicenseStats?.allowMobile && (
            <Box direction="row">
              <Box classes="adminConfig-subject">
                <Typography
                  type="subtitle2"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.config.mobileApp")}
                </Typography>
              </Box>
              <Box classes="adminConfig-info" direction="column">
                <Typography type="subtitle2">
                  {t("admin.config.mobileViewApp")}
                </Typography>
                {pageType === "view" ? (
                  <Typography type="body2_rg" classes="mg mt-12">
                    {ecoCommonConfig.allowMobile
                      ? t("admin.common.label.allow")
                      : t("admin.common.label.disallow")}
                    {ecoCommonConfig.applicationPlatformPolicyDTO?.ios
                      ?.applicationDocumentViewerType &&
                      ecoCommonConfig.allowMobile &&
                      ` (${t(
                        "admin.config.viewIn." +
                          ecoCommonConfig.applicationPlatformPolicyDTO?.ios
                            ?.applicationDocumentViewerType
                      )})`}
                  </Typography>
                ) : (
                  <Box height={40} classes="mg mt-12">
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        label={t("admin.common.label.allow")}
                        check={ecoCommonConfigTemp.allowMobile}
                        onClick={() =>
                          handleChangeConfigEdit("allowMobile", "WEBOFFICE")
                        }
                      />
                      <Dropdown
                        value={
                          ecoCommonConfigTemp.applicationPlatformPolicyDTO?.ios
                            ?.applicationDocumentViewerType
                            ? t(
                                "admin.config.viewIn." +
                                  ecoCommonConfigTemp
                                    .applicationPlatformPolicyDTO?.ios
                                    ?.applicationDocumentViewerType
                              )
                            : t("admin.config.viewIn.WEBOFFICE")
                        }
                        placeholder=" "
                        showValue
                        classes="mg ml-16"
                        buttonClick={buttonClick}
                        disabled={!ecoCommonConfigTemp.allowMobile}
                      >
                        {[
                          {
                            label: t("admin.config.viewIn.NATIVE"),
                            type: "NATIVE",
                          },
                          {
                            label: t("admin.config.viewIn.WEBOFFICE"),
                            type: "WEBOFFICE",
                          },
                        ].map((item) => (
                          <DropdownItem
                            label={item.label}
                            onClick={(e) => {
                              changeButtonClick(buttonClick + 1);
                              setEcoCommonConfigTemp({
                                ...ecoCommonConfigTemp,
                                applicationPlatformPolicyDTO: {
                                  ...ecoCommonConfigTemp.applicationPlatformPolicyDTO,
                                  ios: {
                                    ...ecoCommonConfigTemp
                                      .applicationPlatformPolicyDTO?.ios,
                                    applicationDocumentViewerType:
                                      item.type === "WEBOFFICE"
                                        ? "WEBOFFICE"
                                        : "NATIVE",
                                  },
                                  android: {
                                    ...ecoCommonConfigTemp
                                      .applicationPlatformPolicyDTO?.android,
                                    applicationDocumentViewerType:
                                      item.type === "WEBOFFICE"
                                        ? "WEBOFFICE"
                                        : "NATIVE",
                                  },
                                },
                              });
                            }}
                          />
                        ))}
                      </Dropdown>
                    </Box>
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        label={t("admin.common.label.disallow")}
                        check={!ecoCommonConfigTemp.allowMobile}
                        onClick={() =>
                          handleChangeConfigEdit("allowMobile", "false")
                        }
                      />
                    </Box>
                  </Box>
                )}

                <Typography type="subtitle2" classes="mg mt-32">
                  {t("admin.config.macViewApp")}
                </Typography>
                <Typography
                  type="body4_rg"
                  classes="mg mt-4"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.config.macViewAppDesc")}
                </Typography>
                {pageType === "view" ? (
                  <Typography type="body2_rg" classes="mg mt-12">
                    {ecoCommonConfig.applicationPlatformPolicyDTO?.macos
                      ?.applicationDocumentViewerType === "WEBOFFICE"
                      ? t("admin.common.label.allow")
                      : t("admin.common.label.disallow")}
                  </Typography>
                ) : (
                  <Box height={40} classes="mg mt-12">
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        label={t("admin.common.label.allow")}
                        check={
                          ecoCommonConfigTemp.applicationPlatformPolicyDTO
                            ?.macos?.applicationDocumentViewerType ===
                          "WEBOFFICE"
                        }
                        onClick={() =>
                          handleChangeConfigEdit(
                            "allowMacMobileApp",
                            "WEBOFFICE"
                          )
                        }
                      />
                    </Box>
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        label={t("admin.common.label.disallow")}
                        check={
                          ecoCommonConfigTemp.applicationPlatformPolicyDTO
                            ?.macos?.applicationDocumentViewerType !==
                          "WEBOFFICE"
                        }
                        onClick={() =>
                          handleChangeConfigEdit("allowMacMobileApp", "NONE")
                        }
                      />
                    </Box>
                  </Box>
                )}
                <Typography type="subtitle2" classes="mg mt-32">
                  {t("admin.config.webViewApp")}
                </Typography>
                <Typography
                  type="body4_rg"
                  classes="mg mt-4"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.config.webViewAppDesc")}
                </Typography>
                {pageType === "view" ? (
                  <Typography type="body2_rg" classes="mg mt-12">
                    {ecoCommonConfig.applicationPlatformPolicyDTO?.windows
                      ?.applicationDocumentViewerType === "WEBOFFICE"
                      ? t("admin.common.label.allow")
                      : t("admin.common.label.disallow")}
                  </Typography>
                ) : (
                  <Box height={40} classes="mg mt-12">
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        label={t("admin.common.label.allow")}
                        check={
                          ecoCommonConfigTemp.applicationPlatformPolicyDTO
                            ?.windows?.applicationDocumentViewerType ===
                          "WEBOFFICE"
                        }
                        onClick={() =>
                          handleChangeConfigEdit("allowWINDOWS", "WEBOFFICE")
                        }
                      />
                    </Box>
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        label={t("admin.common.label.disallow")}
                        check={
                          ecoCommonConfigTemp.applicationPlatformPolicyDTO
                            ?.windows?.applicationDocumentViewerType !==
                          "WEBOFFICE"
                        }
                        onClick={() =>
                          handleChangeConfigEdit("allowWINDOWS", "NONE")
                        }
                      />
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          )}
          {userEcoSystemLicenseStats?.allowMacOS && (
            <Box direction="row">
              <Box classes="adminConfig-subject">
                <Typography
                  type="subtitle2"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.config.allowMacOS")}
                </Typography>
              </Box>
              <Box classes="adminConfig-info">
                <Box direction="row">
                  <Box minWidth={"25%"} classes="mg mr-8">
                    <Radio
                      disable={pageType === "view"}
                      check={
                        pageType === "view"
                          ? ecoCommonConfig.allowMacOS
                          : ecoCommonConfigTemp.allowMacOS
                      }
                      label={t("admin.common.label.allow")}
                      onClick={() =>
                        handleChangeConfigEdit("allowMacOS", "true")
                      }
                    />
                  </Box>
                  <Box minWidth={"25%"} classes="mg mr-8">
                    <Radio
                      disable={pageType === "view"}
                      check={
                        pageType === "view"
                          ? !ecoCommonConfig.allowMacOS
                          : !ecoCommonConfigTemp.allowMacOS
                      }
                      label={t("admin.common.label.disallow")}
                      onClick={() =>
                        handleChangeConfigEdit("allowMacOS", "false")
                      }
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
          {userEcoSystemLicenseStats?.allowWebView && (
            <Box direction="row">
              <Box classes="adminConfig-subject">
                <Typography
                  type="subtitle2"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.config.webOfficeType")}
                </Typography>
              </Box>
              <Box classes="adminConfig-info">
                {userEcoSystemLicenseStats?.allowWebView &&
                !utilsCommon.isAvailableWebOffice(
                  fwoc,
                  ecoCommonConfigData?.webOfficeType + ""
                ) &&
                !utilsCommon.isAvailableAnotherWebOffice(fwoc) ? (
                  <Typography type="body2_rg">
                    {t("admin.config.noSupportedWebOffice")}
                  </Typography>
                ) : pageType === "edit" ? (
                  <Dropdown
                    btnSize="sm"
                    placeholder=" "
                    width={160}
                    buttonClick={buttonClick}
                    value={convertConfigWebOfficeType(
                      ecoCommonConfigData?.webOfficeType + ""
                    )}
                  >
                    {[
                      {
                        value: "OOS",
                      },
                      {
                        value: "OFFICE365",
                      },
                      {
                        value: "THINKFREE",
                      },
                      {
                        value: "COLLABORA",
                      },
                    ].map((item) => (
                      <DropdownItem
                        label={convertConfigWebOfficeType(item.value)}
                        onClick={() => {
                          handleChangeConfigEdit("webOfficeType", item.value);
                          changeButtonClick(buttonClick + 1);
                        }}
                      />
                    ))}
                  </Dropdown>
                ) : utilsCommon.isAvailableWebOffice(
                    fwoc,
                    ecoCommonConfigData?.webOfficeType + ""
                  ) ? (
                  <Typography type="body2_rg">
                    {convertConfigWebOfficeType(
                      ecoCommonConfigData?.webOfficeType + ""
                    )}
                  </Typography>
                ) : ecoCommonConfigData.webOfficeType === "NONE" ? (
                  <Typography type="body2_rg">
                    {t("admin.config.noSelectedWebOffice")}
                  </Typography>
                ) : (
                  t("admin.config.chooseWebOffice")
                )}
              </Box>
            </Box>
          )}
          {ecoCommonConfigData?.userOtpType &&
            window.eco.serviceType !== "OCI" && (
              <Box direction="row">
                <Box classes="adminConfig-subject">
                  <Typography
                    type="subtitle2"
                    exactColor={getColor("COLOR_TEXT_SECONDARY")}
                  >
                    {t("admin.config.applyOTP")}
                  </Typography>
                </Box>
                {ecoCommonConfigData?.userOtpType === "USE_SEPARATE_SETTING" ? (
                  <Box classes="adminConfig-info">
                    {pageType === "view" && (
                      <Typography type="body2_rg">
                        {applyOtpType(ecoCommonConfigData.userOtpType)}
                      </Typography>
                    )}
                    {pageType === "edit" && (
                      <Box direction="row">
                        <Box minWidth={"25%"} classes="mg mr-8">
                          <Checkbox
                            check={
                              ecoCommonConfigData.userOtpType ===
                                "USE_SEPARATE_SETTING" &&
                              ecoCommonConfigData.internalUserOtpType !== "NONE"
                            }
                            label={t("admin.dept.internalUser")}
                            onClick={() => handleUseOtp("internal")}
                          />
                          <Dropdown
                            classes="mg ml-16"
                            btnSize="sm"
                            placeholder=" "
                            width={160}
                            buttonClick={buttonClick}
                            disabled={
                              !(
                                ecoCommonConfigData.userOtpType ===
                                  "USE_SEPARATE_SETTING" &&
                                ecoCommonConfigData.internalUserOtpType !==
                                  "NONE"
                              )
                            }
                            value={
                              ecoCommonConfigData.internalUserOtpType ??
                              "GOOGLE_OTP"
                            }
                          >
                            <DropdownItem
                              label={"GOOGLE_OTP"}
                              onClick={() => {
                                handleChangeConfigEdit(
                                  "internalUserOtpType",
                                  "GOOGLE_OTP"
                                );
                                changeButtonClick(buttonClick + 1);
                              }}
                            />
                            <DropdownItem
                              label={"MAIL_OTP"}
                              onClick={() => {
                                handleChangeConfigEdit(
                                  "internalUserOtpType",
                                  "MAIL_OTP"
                                );
                                changeButtonClick(buttonClick + 1);
                              }}
                            />
                            {window.eco.esetOTP && (
                              <DropdownItem
                                label={"ESET_OTP"}
                                onClick={() => {
                                  handleChangeConfigEdit(
                                    "internalUserOtpType",
                                    "ESET_OTP"
                                  );
                                  changeButtonClick(buttonClick + 1);
                                }}
                              />
                            )}
                          </Dropdown>
                        </Box>
                        <Box minWidth={"25%"} classes="mg mr-8">
                          <Checkbox
                            check={
                              ecoCommonConfigData.userOtpType ===
                                "USE_SEPARATE_SETTING" &&
                              ecoCommonConfigData.externalUserOtpType !== "NONE"
                            }
                            label={t("admin.dept.externalUser")}
                            onClick={() => handleUseOtp("external")}
                          />
                          <Dropdown
                            classes="mg ml-16"
                            btnSize="sm"
                            placeholder=" "
                            width={160}
                            buttonClick={buttonClick}
                            disabled={
                              !(
                                ecoCommonConfigData.userOtpType ===
                                  "USE_SEPARATE_SETTING" &&
                                ecoCommonConfigData.externalUserOtpType !==
                                  "NONE"
                              )
                            }
                            value={
                              ecoCommonConfigData.externalUserOtpType ?? ""
                            }
                          >
                            <DropdownItem
                              label={"GOOGLE_OTP"}
                              onClick={() => {
                                handleChangeConfigEdit(
                                  "externalUserOtpType",
                                  "GOOGLE_OTP"
                                );
                                changeButtonClick(buttonClick + 1);
                              }}
                            />
                            <DropdownItem
                              label={"MAIL_OTP"}
                              onClick={() => {
                                handleChangeConfigEdit(
                                  "externalUserOtpType",
                                  "MAIL_OTP"
                                );
                                changeButtonClick(buttonClick + 1);
                              }}
                            />
                            {window.eco.esetOTP && (
                              <DropdownItem
                                label={"ESET_OTP"}
                                onClick={() => {
                                  handleChangeConfigEdit(
                                    "externalUserOtpType",
                                    "ESET_OTP"
                                  );
                                  changeButtonClick(buttonClick + 1);
                                }}
                              />
                            )}
                          </Dropdown>
                        </Box>
                      </Box>
                    )}
                  </Box>
                ) : (
                  <Box classes="adminConfig-info">
                    <Box direction="row">
                      <Box minWidth={"25%"} classes="mg mr-8">
                        <Radio
                          label={t("admin.common.label.noUser")}
                          disable={pageType === "view"}
                          check={ecoCommonConfigData.userOtpType === "NONE"}
                          onClick={() =>
                            handleChangeConfigEdit("userOtpType", "NONE")
                          }
                        />
                      </Box>
                      <Box minWidth={"25%"} classes="mg mr-8">
                        <Radio
                          label={t("admin.common.label.allUser")}
                          disable={pageType === "view"}
                          check={ecoCommonConfigData.userOtpType === "ALL"}
                          onClick={() =>
                            handleChangeConfigEdit("userOtpType", "ALL")
                          }
                        />
                      </Box>
                      <Box minWidth={"25%"} classes="mg mr-8">
                        <Radio
                          label={t("admin.dept.internalUser")}
                          disable={pageType === "view"}
                          check={ecoCommonConfigData.userOtpType === "INTERNAL"}
                          onClick={() =>
                            handleChangeConfigEdit("userOtpType", "INTERNAL")
                          }
                        />
                      </Box>
                      <Box minWidth={"25%"} classes="mg mr-8">
                        <Radio
                          label={t("admin.dept.externalUser")}
                          disable={pageType === "view"}
                          check={ecoCommonConfigData.userOtpType === "EXTERNAL"}
                          onClick={() =>
                            handleChangeConfigEdit("userOtpType", "EXTERNAL")
                          }
                        />
                      </Box>
                    </Box>
                  </Box>
                )}
              </Box>
            )}
          <Box>
            <Box classes="adminConfig-subject">
              <Typography
                type="subtitle2"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.config.accessControl.title")}
              </Typography>
            </Box>

            <Box classes="adminConfig-info" direction="column">
              {pageType === "view" &&
                (allowIpList.length === 0 ? (
                  <Box classes="adminConfig-info">
                    <Typography type="body2_rg">
                      {t("admin.config.accessControl.noRegisterdIpRange")}
                    </Typography>
                  </Box>
                ) : (
                  allowIpList.map((item, idx) => {
                    return (
                      <Box classes={idx > 0 ? "mg mt-8" : ""}>
                        <Typography type="body2_rg">
                          {item.ipFromStr}
                          &nbsp;~&nbsp;
                          {item.ipToStr}
                        </Typography>
                      </Box>
                    );
                  })
                ))}
              {pageType === "edit" && (
                <Box direction="row">
                  <Box width={300} alignItems="center">
                    <Button
                      type="primary"
                      btnStyle="link"
                      label={t("admin.config.insertIpRange")}
                      onClick={() => addIpItem("range")}
                      size="sm"
                      leadingIcon={
                        <Icons
                          variant="line"
                          label="plusCircle"
                          stroke={getColor("COLOR_ICON_BRAND")}
                        />
                      }
                      textColor={getColor("COLOR_TEXT_BRAND")}
                    />
                    {allowIpListTemp.length === 0 ? (
                      <Typography classes="mg ml-20" type="body2_rg">
                        {t("admin.config.accessControl.noRegisterdIpRange")}
                      </Typography>
                    ) : (
                      <Typography classes="mg ml-20" type="body2_rg">
                        {t("admin.config.registeredIpRange", {
                          ipCount: allowIpListTemp.length,
                        })}
                      </Typography>
                    )}
                  </Box>
                  <Box direction="column">
                    {allowIpListTemp.map((item, index) => {
                      return (
                        <Box classes={index > 0 ? "mg mt-8" : ""}>
                          <InputField
                            value={getIpClass(item["ipFromStr"], 0)}
                            onChange={(e) =>
                              handleChangeIp(index, "fromIp1", e.target.value)
                            }
                            maxLength={3}
                            placeholder={""}
                            width={40}
                          />
                          <InputField
                            value={getIpClass(item["ipFromStr"], 1)}
                            onChange={(e) =>
                              handleChangeIp(index, "fromIp2", e.target.value)
                            }
                            maxLength={3}
                            placeholder={""}
                            width={40}
                            classes="mg ml-8"
                          />
                          <InputField
                            value={getIpClass(item["ipFromStr"], 2)}
                            onChange={(e) =>
                              handleChangeIp(index, "fromIp3", e.target.value)
                            }
                            maxLength={3}
                            placeholder={""}
                            width={40}
                            classes="mg ml-8"
                          />
                          <InputField
                            value={getIpClass(item["ipFromStr"], 3)}
                            onChange={(e) =>
                              handleChangeIp(index, "fromIp4", e.target.value)
                            }
                            maxLength={3}
                            placeholder={""}
                            width={40}
                            classes="mg ml-8"
                          />
                          <Box alignItems="center" classes="mg ml-8 mr-8">
                            ~
                          </Box>
                          <InputField
                            value={getIpClass(item["ipToStr"], 0)}
                            onChange={(e) =>
                              handleChangeIp(index, "toIp1", e.target.value)
                            }
                            maxLength={3}
                            placeholder={""}
                            width={40}
                          />
                          <InputField
                            value={getIpClass(item["ipToStr"], 1)}
                            onChange={(e) =>
                              handleChangeIp(index, "toIp2", e.target.value)
                            }
                            maxLength={3}
                            placeholder={""}
                            width={40}
                            classes="mg ml-8"
                          />
                          <InputField
                            value={getIpClass(item["ipToStr"], 2)}
                            onChange={(e) =>
                              handleChangeIp(index, "toIp3", e.target.value)
                            }
                            maxLength={3}
                            placeholder={""}
                            width={40}
                            classes="mg ml-8"
                          />
                          <InputField
                            value={getIpClass(item["ipToStr"], 3)}
                            onChange={(e) =>
                              handleChangeIp(index, "toIp4", e.target.value)
                            }
                            maxLength={3}
                            placeholder={""}
                            width={40}
                            classes="mg ml-8"
                          />
                          <Button
                            type="error"
                            btnStyle="link"
                            onClick={() =>
                              setAllowIpListTemp((prevList) => {
                                const newList = [...prevList];
                                newList.splice(index, 1); // 인덱스 2에서 1개의 요소를 제거
                                return newList;
                              })
                            }
                            leadingIcon={
                              <Icons variant="line" label="delete" />
                            }
                            classes="mg ml-8"
                          />
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
          {window.eco.companyName !== "workspace" && (
            <Box direction="row">
              <Box classes="adminConfig-subject">
                <Typography
                  type="subtitle2"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {t("admin.config.watermark")}
                </Typography>
              </Box>
              <Box classes="adminConfig-info" direction="column">
                {pageType === "view" && (
                  <Box>
                    <Typography type="body2_rg">
                      {ecoCommonConfigData.watermark === "ALL"
                        ? t("admin.common.label.use")
                        : t("admin.common.label.doNotUse")}
                    </Typography>
                  </Box>
                )}
                {pageType === "edit" && (
                  <Box direction="row">
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        check={ecoCommonConfigData.watermark === "ALL"}
                        label={t("admin.common.label.use")}
                        onClick={() =>
                          handleChangeConfigEdit("watermark", "ALL")
                        }
                      />
                    </Box>
                    <Box minWidth={"25%"} classes="mg mr-8">
                      <Radio
                        check={ecoCommonConfigData.watermark === "NONE"}
                        label={t("admin.common.label.doNotUse")}
                        onClick={() =>
                          handleChangeConfigEdit("watermark", "NONE")
                        }
                      />
                    </Box>
                  </Box>
                )}
                <Box classes="mg mt-8" direction="row" alignItems="center">
                  {((pageType === "view" &&
                    ecoCommonConfig.watermark === "ALL") ||
                    (pageType === "edit" &&
                      ecoCommonConfigTemp.watermark === "ALL")) && (
                    <Typography type="body2_rg">
                      {showScreenWaterMark()}
                      {pageType === "view" &&
                      showScreenWaterMark().trim().endsWith("/")
                        ? t("admin.whiteLabel.siteName")
                        : ""}
                    </Typography>
                  )}
                  {pageType === "edit" &&
                    ecoCommonConfigTemp.watermark === "ALL" && (
                      <Box>
                        <InputField
                          value={
                            ecoCommonConfigData?.watermarkPattern &&
                            (ecoCommonConfigData?.watermarkPattern.substring(
                              ecoCommonConfigData?.watermarkPattern.lastIndexOf(
                                "/"
                              ) + 2
                            ) === ""
                              ? ""
                              : ecoCommonConfigData.watermarkPattern.substring(
                                  ecoCommonConfigData?.watermarkPattern.lastIndexOf(
                                    "/"
                                  ) + 2
                                ))
                          }
                          onChange={(e) =>
                            updateWatermarkPattern(e.target.value)
                          }
                          maxLength={30}
                          placeholder={t(
                            "admin.config.screenwatermarkPlaceholder"
                          )}
                          width={200}
                          classes="mg ml-8"
                        />
                        <Checkbox
                          classes="mg ml-32"
                          check={ecoCommonConfigData.watermarkPattern?.includes(
                            "${currentfulltime}"
                          )}
                          label={t("admin.config.includeTime")}
                          onClick={() =>
                            handleChangeWatermark("watermarkPatternWithTime")
                          }
                        />
                        <Checkbox
                          classes="mg ml-32"
                          check={ecoCommonConfigData.watermarkPattern?.includes(
                            "${ip}"
                          )}
                          label={t("admin.config.includeIp")}
                          onClick={() =>
                            handleChangeWatermark("watermarkPatternWithIp")
                          }
                        />
                      </Box>
                    )}
                </Box>
                {((pageType === "view" &&
                  ecoCommonConfig.watermark === "ALL") ||
                  (pageType === "edit" &&
                    ecoCommonConfigTemp.watermark === "ALL")) && (
                  <Box classes="mg mt-8" alignItems="center">
                    <Typography type="body2_rg">
                      {t("admin.config.watermarkFontSize")} :
                    </Typography>
                    {pageType === "view" && (
                      <Typography type="body2_rg" classes="mg ml-4">
                        {ecoCommonConfigData.watermarkFontSize}px
                      </Typography>
                    )}
                    {pageType === "edit" && (
                      <InputField
                        classes="mg ml-4"
                        value={ecoCommonConfigData.watermarkFontSize + ""}
                        onChange={(e) =>
                          handleChangeConfigEdit(
                            "watermarkFontSize",
                            e.target.value ?? 0
                          )
                        }
                        type="positive-integer"
                        maxLength={2}
                        placeholder={""}
                        width={74}
                        trailingIcon={"px"}
                      />
                    )}

                    <Typography type="body2_rg" classes="mg ml-4">
                      / {t("admin.config.watermarkOpacity")} :
                    </Typography>
                    {pageType === "view" && (
                      <Typography type="body2_rg" classes="mg ml-4">
                        {ecoCommonConfigData.watermarkOpacity}
                      </Typography>
                    )}
                    {pageType === "edit" && (
                      <InputField
                        classes="mg ml-4"
                        value={ecoCommonConfigData.watermarkOpacity + ""}
                        onChange={(e) =>
                          handleChangeConfigEdit(
                            "watermarkOpacity",
                            e.target.value
                          )
                        }
                        maxLength={4}
                        placeholder={""}
                        width={74}
                      />
                    )}

                    <Typography type="body2_rg" classes="mg ml-4">
                      / {t("admin.config.watermarkRotate")} :
                    </Typography>
                    {pageType === "view" && (
                      <Typography type="body2_rg" classes="mg ml-4">
                        {ecoCommonConfigData.watermarkRotate}°
                      </Typography>
                    )}
                    {pageType === "edit" && (
                      <InputField
                        classes="mg ml-4"
                        value={ecoCommonConfigData.watermarkRotate + ""}
                        onChange={(e) =>
                          handleChangeConfigEdit(
                            "watermarkRotate",
                            e.target.value
                          )
                        }
                        maxLength={4}
                        placeholder={""}
                        width={74}
                        trailingIcon={"°"}
                      />
                    )}

                    <Typography type="body2_rg" classes="mg ml-4">
                      / {t("admin.config.watermarkTop")} :
                    </Typography>
                    {pageType === "view" && (
                      <Typography type="body2_rg" classes="mg ml-4">
                        {ecoCommonConfigData.watermarkTop}%
                      </Typography>
                    )}
                    {pageType === "edit" && (
                      <InputField
                        classes="mg ml-4"
                        value={ecoCommonConfigData.watermarkTop + ""}
                        onChange={(e) =>
                          handleChangeConfigEdit("watermarkTop", e.target.value)
                        }
                        type="positive-integer"
                        maxLength={3}
                        placeholder={""}
                        width={74}
                        trailingIcon={"%"}
                      />
                    )}
                  </Box>
                )}
              </Box>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default AdminConfig;
